"use strict";
function asyncGeneratorStep(e, t, a, s, i, n, r) {
  try {
    var o = e[n](r),
      l = o.value;
  } catch (e) {
    return void a(e);
  }
  o.done ? t(l) : Promise.resolve(l).then(s, i);
}
function _asyncToGenerator(e) {
  return function () {
    var t = this,
      a = arguments;
    return new Promise(function (s, i) {
      function n(e) {
        asyncGeneratorStep(o, s, i, n, r, "next", e);
      }
      function r(e) {
        asyncGeneratorStep(o, s, i, n, r, "throw", e);
      }
      var o = e.apply(t, a);
      n(void 0);
    });
  };
}
function ownKeys(e, t) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    t &&
      (s = s.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })),
      a.push.apply(a, s);
  }
  return a;
}
function _objectSpread(e) {
  for (var t, a = 1; a < arguments.length; a++)
    (t = null == arguments[a] ? {} : arguments[a]),
      a % 2
        ? ownKeys(Object(t), !0).forEach(function (a) {
            _defineProperty(e, a, t[a]);
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
        : ownKeys(Object(t)).forEach(function (a) {
            Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
          });
  return e;
}
function _defineProperty(e, t, a) {
  return (
    (t = _toPropertyKey(t)),
    t in e
      ? Object.defineProperty(e, t, {
          value: a,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (e[t] = a),
    e
  );
}
function _toPropertyKey(e) {
  var t = _toPrimitive(e, "string");
  return "symbol" == typeof t ? t : t + "";
}
function _toPrimitive(e, t) {
  if ("object" != typeof e || null === e) return e;
  var a = e[Symbol.toPrimitive];
  if (a !== void 0) {
    var s = a.call(e, t || "default");
    if ("object" != typeof s) return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === t ? String : Number)(e);
}
var isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform),
  isIpad =
    navigator.maxTouchPoints &&
    2 < navigator.maxTouchPoints &&
    /MacIntel/.test(navigator.platform),
  isIOS = /(iPhone|iPod|iPad)/i.test(navigator.platform),
  isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/),
  isFirefox = -1 < navigator.userAgent.toLowerCase().indexOf("firefox"),
  page_content = window,
  mobile = device.mobile() || isIpad || device.tablet() || isIOS,
  tablet = device.tablet() || isIpad,
  mobileDevice = mobile || tablet || isIOS,
  bufer = 0,
  buferMax = isSafari ? 10 : isFirefox ? 30 : 200,
  window_width = window.innerWidth,
  window_height = window.innerHeight,
  menu_btn_access = !0,
  animTime = 250,
  ease = Power2.out,
  isTablet = 1100 >= window_width,
  isTablet2 = 690 >= window_width,
  isMobile = 540 >= window_width,
  menuIsOpen = !1;
isMacLike && document.body.classList.add("isMacLike"),
  isSafari && document.body.classList.add("isSafari");
var root = document.documentElement,
  deltaVh = vhCheck().vh - vhCheck().windowHeight;
root.style.setProperty("--deltaVh", deltaVh + "px"),
  root.style.setProperty("--vh", vhCheck().vh + "px"),
  root.style.setProperty("--windowHeight", vhCheck().windowHeight + "px"),
  window.addEventListener("resize", function () {
    (isTablet && window_width === window.innerWidth) ||
      ((deltaVh = vhCheck().vh - vhCheck().windowHeight),
      root.style.setProperty("--deltaVh", deltaVh + "px"),
      root.style.setProperty("--vh", vhCheck().vh + "px")),
      root.style.setProperty("--windowHeight", vhCheck().windowHeight + "px"),
      (window_width = window.innerWidth),
      (window_height = window.innerHeight),
      (isTablet = 1100 >= window_width),
      (isTablet2 = 690 >= window_width),
      (isMobile = 540 >= window_width),
      document.body.classList.toggle("isTablet", isTablet),
      document.body.classList.toggle("isMobile", isMobile);
  });
class StyleLoader {
  constructor() {
    var e = this;
    _defineProperty(this, "checkElements", () => {
      try {
        if (!this.styleElements.length) return;
        for (
          var t = function t() {
              var s = e.styleElements[a],
                i = new IntersectionObserver(
                  (t) => {
                    t.forEach((t) => {
                      t.isIntersecting &&
                        (i.disconnect(), e.loadStylesFromDataHref(s));
                    });
                  },
                  { threshold: 0 }
                );
              i.observe(s), e.observers.push(i);
            },
            a = 0;
          a < this.styleElements.length;
          a++
        )
          t();
      } catch (t) {
        console.log(t);
      }
    }),
      (this.styleElements = []),
      (this.observers = []);
  }
  loadStylesFromDataHref(e) {
    try {
      if ("true" == e.getAttribute("data-style-loaded")) return null;
      var t = e.getAttribute("data-fs");
      if (t) {
        var a = document.querySelector("style#".concat(t)) || null;
        if (a)
          return (
            console.log("first screen style", a),
            e.setAttribute("data-style-loaded", "true"),
            (this.styleElements = this.styleElements.filter(
              (e) => "false" == e.dataset.styleLoaded
            )),
            !0
          );
      }
      var s = e.getAttribute("data-style-href");
      if (!s) return null;
      var i =
        document.querySelector(
          'link[rel="stylesheet"][href="'.concat(s, '"]')
        ) || null;
      if (i)
        console.log("style file is loaded early", s),
          e.setAttribute("data-style-loaded", "true"),
          document.dispatchEvent(
            new CustomEvent("loadedStyle", { detail: { href: s } })
          ),
          (this.styleElements = this.styleElements.filter(
            (e) => "false" == e.dataset.styleLoaded
          ));
      else {
        var n = document.createElement("link");
        (n.rel = "stylesheet"),
          (n.href = s),
          (n.onload = () => {
            console.log("style file is loaded", s),
              e.setAttribute("data-style-loaded", "true"),
              document.dispatchEvent(
                new CustomEvent("loadedStyle", { detail: { href: s } })
              ),
              (this.styleElements = this.styleElements.filter(
                (e) => "false" == e.dataset.styleLoaded
              ));
          }),
          document.head.appendChild(n);
      }
    } catch (t) {
      console.log(t);
    }
  }
  init() {
    try {
      if (
        ((this.styleElements =
          Array.from(
            document.querySelectorAll(
              '[data-style-href][data-style-loaded="false"]'
            )
          ) || []),
        !this.styleElements.length)
      )
        return null;
      this.checkElements();
    } catch (t) {
      console.log(t);
    }
  }
  destroy() {
    try {
      this.observers.length &&
        (this.observers.forEach((e) => {
          e.disconnect();
        }),
        (this.observers = [])),
        (this.styleElements = []);
    } catch (t) {
      console.log(t);
    }
  }
}
class ScriptLoader {
  constructor() {
    var e = this;
    _defineProperty(this, "checkElements", () => {
      try {
        if (!this.scriptElems.length) return;
        for (
          var t = function t() {
              var s = e.scriptElems[a],
                i = new IntersectionObserver(
                  (t) => {
                    t.forEach((t) => {
                      t.isIntersecting &&
                        (i.disconnect(), e.loadScriptFromDataHref(s));
                    });
                  },
                  { threshold: 0 }
                );
              i.observe(s), e.observers.push(i);
            },
            a = 0;
          a < this.scriptElems.length;
          a++
        )
          t();
      } catch (t) {
        console.log(t);
      }
    }),
      (this.scriptElems = []),
      (this.observers = []),
      (this.scripts = []);
  }
  loadScriptFromDataHref(e) {
    try {
      if ("true" == e.getAttribute("data-script-init")) return null;
      var t = e.getAttribute("data-script-src");
      if (!t) return null;
      var a = document.createElement("script");
      (a.async = !0),
        (a.src = t),
        (a.onload = () => {
          console.log("script file is loaded", t),
            e.setAttribute("data-script-init", "true"),
            this.scriptElems.forEach((e) => {
              e.getAttribute("data-script-src") === t &&
                e.setAttribute("data-script-init", "true");
            });
        }),
        document.body.appendChild(a),
        this.scripts.push(a);
    } catch (t) {
      console.log(t);
    }
  }
  init() {
    try {
      if (
        ((this.scriptElems =
          Array.from(
            document.querySelectorAll(
              '[data-script-src][data-script-init="false"]'
            )
          ) || []),
        !this.scriptElems.length)
      )
        return null;
      this.checkElements();
    } catch (t) {
      console.log(t);
    }
  }
  destroy() {
    try {
      this.observers.length &&
        (this.observers.forEach((e) => {
          e.disconnect();
        }),
        (this.observers = [])),
        this.scripts.length &&
          (this.scripts.forEach((e) => {
            e && e.remove();
          }),
          (this.scripts = [])),
        (this.scriptElems = []);
    } catch (t) {
      console.log(t);
    }
  }
}
var OBSERVER_LOADERS = [new StyleLoader(), new ScriptLoader()],
  LOADED_SCRIPTS_PACK = [];
class AnimatedElementsObserver {
  constructor() {
    (this.elements = []), (this.intersectionObservers = new Map());
  }
  init() {
    (this.elements = document.querySelectorAll('[data-animated="false"]')),
      this.elements.forEach((e) => {
        var t = this.getRootMargin(e),
          a = new IntersectionObserver((e) => this.handleIntersection(e), {
            threshold: 0.01,
            rootMargin: t,
          });
        a.observe(e), this.intersectionObservers.set(e, a);
      });
  }
  destroy() {
    this.intersectionObservers.forEach((e) => {
      e.disconnect();
    }),
      this.intersectionObservers.clear(),
      (this.elements = []);
  }
  checkSvgAnimation(e) {
    try {
      var t = Array.from(
        e.querySelectorAll('animate[data-svg-animate="false"]')
      );
      t.length &&
        t.forEach((e) => {
          e.beginElement();
        });
    } catch (t) {
      console.log(t);
    }
  }
  getRootMargin(e) {
    var t = e.getAttribute("data-animated-margin-top"),
      a = e.getAttribute("data-animated-margin-bottom");
    return t || a
      ? "".concat(t || "0px", " 0px ").concat(a || "0px", " 0px")
      : "0px";
  }
  handleIntersection(e) {
    e.forEach((e) => {
      if (e.isIntersecting) {
        var t = e.target;
        t.setAttribute("data-animated", "true"), this.checkSvgAnimation(t);
        var a = this.intersectionObservers.get(t);
        a.unobserve(t);
      }
    });
  }
}
var ANIME_ELEMENTS_OBSERVER = new AnimatedElementsObserver();
function fadeIn(e) {
  function t(i) {
    s || (s = i);
    var n = i - s,
      r = n / a;
    (e.style.opacity = 1 <= r ? 1 : r),
      1 > r && window.requestAnimationFrame(t);
  }
  var a = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : 250;
  (e.style.opacity = 0), (e.style.display = "block");
  var s = null;
  window.requestAnimationFrame(t);
}
function fadeOut(e) {
  function t(n) {
    s || (s = n);
    var r = n - s,
      o = r / a;
    (e.style.opacity = i * (1 - o)),
      1 > o ? window.requestAnimationFrame(t) : (e.style.display = "none");
  }
  var a = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : 250,
    s = null,
    i = parseFloat(window.getComputedStyle(e).opacity);
  window.requestAnimationFrame(t);
}
function rnd(e, t) {
  var a = Math.round,
    s = e - 0.5 + Math.random() * (t - e + 1);
  return (s = a(s)), s;
}
function animateFromTo(e, t, a, s) {
  var i = 4 < arguments.length && arguments[4] !== void 0 ? arguments[4] : 0;
  gsap
    .fromTo(e, _objectSpread(_objectSpread({}, a), {}, { duration: t }), s)
    .delay(i);
}
function getScrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth;
}
function disableScroll() {
  var e = getScrollbarWidth();
  document.documentElement.style.setProperty("--scrollBarWidth", e + "px"),
    (document.body.style.overflow = "hidden"),
    (document.querySelector(".wrapper").style.paddingRight = e + "px"),
    (document.querySelector(".header").style.right = e + "px"),
    document.body.classList.add("scrollLock"),
    document.dispatchEvent(new CustomEvent("lenis:stop"));
}
function enableScroll() {
  (document.body.style.overflow = ""),
    (document.querySelector(".wrapper").style.paddingRight = ""),
    (document.querySelector(".header").style.right = ""),
    document.body.classList.remove("scrollLock"),
    document.documentElement.style.setProperty("--scrollBarWidth", 0),
    document.dispatchEvent(new CustomEvent("lenis:start"));
}
function shopifyFormatedPrice(e) {
  function t(e, t) {
    return "undefined" == typeof e ? t : e;
  }
  function a(e, a, s, i) {
    if (
      ((a = t(a, 2)), (s = t(s, ",")), (i = t(i, ".")), isNaN(e) || null == e)
    )
      return 0;
    e = (e / 100).toFixed(a);
    var n = e.split("."),
      r = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + s),
      o = n[1] ? i + n[1] : "";
    return r + o;
  }
  var s =
    1 < arguments.length && arguments[1] !== void 0
      ? arguments[1]
      : "${{amount}}";
  "string" == typeof e && (e = e.replace(".", ""));
  var i = "",
    n = /\{\{\s*(\w+)\s*\}\}/,
    r = s;
  switch (r.match(n)[1]) {
    case "amount":
      i = a(e, 2);
      break;
    case "amount_no_decimals":
      i = a(e, 0);
      break;
    case "amount_with_comma_separator":
      i = a(e, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      i = a(e, 0, ".", ",");
  }
  return r.replace(n, i);
}
window.addEventListener("load", function () {
  document.body.classList.add("init");
});
var initThrottle = () => {
  var e;
  return {
    init: (t, a) => {
      e ||
        (clearTimeout(e),
        (e = setTimeout(() => {
          t(), clearTimeout(e), (e = !1);
        }, a)));
    },
    clear: () => {
      clearTimeout(e), (e = null);
    },
  };
};
class ActiveLink {
  constructor() {
    this.activeLinks = [];
  }
  init() {
    var e = Array.from(document.querySelectorAll("a")) || [],
      t = window.location.href;
    e.forEach((e) => {
      var a = e.href;
      a === t && (e.classList.add("current-route"), this.activeLinks.push(e));
    });
  }
  destroy() {
    this.activeLinks.length &&
      (this.activeLinks.forEach((e) => {
        e.classList.remove("current-route");
      }),
      (this.activeLinks = []));
  }
}
class HeaderControll {
  constructor() {
    _defineProperty(this, "startMarquee", () => {
      if (!this.notification) return null;
      if (!this.notification.classList.contains("show")) return null;
      var e = this.notification.querySelector(".content"),
        t = parseInt(window.getComputedStyle(this.notification).paddingLeft),
        a = parseInt(window.getComputedStyle(this.notification).paddingRight),
        s = this.notification.clientWidth - (t + a),
        i = e.offsetWidth;
      i > s
        ? (this.notification.classList.add("marquee"),
          e.classList.add("marquee-action"),
          (e.style.animation = "marquee ".concat(i / 35, "s linear infinite")))
        : (this.notification.classList.remove("marquee"),
          e.classList.remove("marquee-action"),
          e.removeAttribute("style"));
    }),
      _defineProperty(this, "mouseEnter", (t) => {
        (this.mouseOnHeader = !0),
          this.header.classList.contains("hide") &&
            this.header.classList.remove("hide");
      }),
      _defineProperty(this, "mouseLeave", (t) => {
        this.mouseOnHeader = !1;
      }),
      _defineProperty(this, "mouseenter", (t) => {
        document.documentElement.style.setProperty(
          "--submenuwidth",
          t.target.offsetWidth + "px"
        ),
          t.target.classList.add("hover");
        var e = t.target.querySelector(".sub-menu") || null;
        return e
          ? void (this.currentOpensubMenu
              ? (clearTimeout(this.timeoutSubmenu),
                this.currentOpensubMenu.classList.remove("display"),
                (this.currentOpensubMenu = e),
                this.currentOpensubMenu.classList.add("display"),
                requestAnimationFrame(() => {
                  (this.currentOpensubMenu.style.transition = "none"),
                    this.currentOpensubMenu.classList.add("show"),
                    this.header.classList.add("open-sub-menu"),
                    requestAnimationFrame(() =>
                      this.currentOpensubMenu.removeAttribute("style")
                    );
                }))
              : ((this.currentOpensubMenu = e),
                this.currentOpensubMenu.classList.add("display"),
                requestAnimationFrame(() => {
                  this.currentOpensubMenu.classList.add("show"),
                    this.header.classList.add("open-sub-menu");
                })))
          : null;
      }),
      _defineProperty(
        this,
        "mouseleave",
        (t) => (
          this.mouseEnterTimeout &&
            (clearTimeout(this.mouseEnterTimeout),
            (this.mouseEnterTimeout = null),
            (this.mouseEnterHasTimeout = !1)),
          t.target.classList.remove("hover"),
          this.currentOpensubMenu
            ? void (this.header.classList.remove("open-sub-menu"),
              this.currentOpensubMenu.classList.remove("show"),
              (this.timeoutSubmenu = setTimeout(() => {
                this.currentOpensubMenu.classList.remove("display"),
                  (this.currentOpensubMenu = null);
              }, 200)))
            : null
        )
      ),
      _defineProperty(this, "toggleFilterPanel", () => {
        var e,
          t =
            (null === (e = this.catalogFilterPanel) || void 0 === e
              ? void 0
              : e.offsetHeight) || 0,
          a = this.catalogParent.getBoundingClientRect(),
          s = a.top + this.scrollPos - t,
          i = s + this.catalogParent.offsetHeight,
          n = this.header.offsetHeight || 0,
          r = s <= this.scrollPos && i > this.scrollPos;
        return r
          ? this.isScrollDown && 0 < window.pageYOffset
            ? !(0 >= window.pageYOffset) &&
              (1 == this.catalogFilterPanelState ||
                (this.header.classList.add("hide"),
                this.header.classList.remove("bg--light-grey"),
                this.catalogFilterPanel.classList.remove("slide"),
                this.catalogFilterPanel.removeAttribute("style"),
                (this.catalogFilterPanelState = 1),
                !0))
            : 2 == this.catalogFilterPanelState ||
              (this.catalogFilterPanel.classList.add("slide"),
              (this.catalogFilterPanel.style.top = n - 1 + "px"),
              this.header.classList.remove("hide"),
              this.header.classList.add("bg--light-grey"),
              (this.catalogFilterPanelState = 2),
              !0)
          : !(3 != this.catalogFilterPanelState) ||
              (this.catalogFilterPanel.classList.remove("slide"),
              this.catalogFilterPanel.removeAttribute("style"),
              this.header.classList.remove("hide"),
              this.header.classList.remove("bg--light-grey"),
              (this.catalogFilterPanelState = 3),
              !0);
      }),
      _defineProperty(this, "scroll", () => {
        null === this.scrollPos && (this.scrollPos = window.pageYOffset),
          window.pageYOffset > this.moveTrigger
            ? this.header.classList.add("move")
            : this.header.classList.remove("move"),
          (this.isScrollDown = window.pageYOffset > this.scrollPos),
          (this.scrollPos = window.pageYOffset),
          this.catalogFilterPanel && this.toggleFilterPanel();
      }),
      _defineProperty(this, "openMobNavMenu", (t) => {
        disableScroll(),
          (this.isOpenMobileMenu = !0),
          this.mobileParent.classList.add("display"),
          requestAnimationFrame(() => {
            this.mobileParent.classList.add("show");
          });
      }),
      _defineProperty(this, "closeMobNavMenu", (t) => {
        enableScroll(),
          this.mobileParent.classList.remove("show"),
          setTimeout(() => {
            this.mobileParent.classList.remove("display"),
              (this.isOpenMobileMenu = !1);
          }, 300);
      }),
      _defineProperty(this, "focusToInput", (t) => {
        var e = t.target.closest(".search"),
          a = e.querySelector(".box > input");
        a.focus();
      }),
      _defineProperty(this, "openMobSubMenu", (t) => {
        var e = t.target.closest(".has-sub-menu"),
          a = e.querySelector(".sub-menu");
        if (e.classList.contains("open"))
          e.classList.remove("open"), a.removeAttribute("style");
        else {
          e.classList.add("open");
          var s = a.scrollHeight;
          a.style.maxHeight = s + "px";
        }
      }),
      _defineProperty(this, "click", (t) => {
        var e = t.target.closest('[data-btn-action="close_notification"]');
        if (e) return this.closeNotification();
        var a = t.target.closest('[data-button-action="open_mob_menu"]');
        if (a) return this.openMobNavMenu();
        var s = t.target.closest('[data-button-action="focus_on_input"]');
        if (s) return this.focusToInput(t);
        if (this.isOpenMobileMenu) {
          var i = t.target.closest(".has-sub-menu");
          if (i) return this.openMobSubMenu(t);
          var n = t.target.closest('[data-button-action="close_mob_menu"]');
          if (n) return this.closeMobNavMenu();
        }
      }),
      _defineProperty(this, "closeNotification", (t) => {
        sessionStorage.setItem("notification-watch", !0),
          this.notification.classList.remove("show");
        var e = document.querySelector(".wrapper");
        if (
          (e.classList.add("min"),
          this.notification.classList.contains("marquee"))
        ) {
          var a = this.notification.querySelector(".content");
          a.classList.remove("marquee-action"),
            this.notification.classList.remove("marquee");
        }
        this.catalogFilterPanel &&
          (this.catalogFilterPanel.removeAttribute("style"),
          setTimeout(this.toggleFilterPanel, 200));
      }),
      _defineProperty(this, "checkNotification", () => {
        try {
          if (
            ((this.notification =
              document.querySelector("header .notification") || null),
            !this.notification)
          )
            return null;
          var e = sessionStorage.getItem("notification-watch");
          if (!e) this.notification.classList.add("show");
          else {
            var t = document.querySelector(".wrapper");
            t.classList.add("min");
          }
        } catch (t) {}
      }),
      _defineProperty(this, "toDefaultState", () => {
        this.isOpenMobileMenu && this.closeMobNavMenu(),
          this.currentOpensubMenu &&
            (this.currentOpensubMenu.closest(".hover") &&
              this.currentOpensubMenu
                .closest(".hover")
                .classList.remove("hover"),
            this.currentOpensubMenu.classList.remove("display", "show"),
            (this.currentOpensubMenu = null),
            this.header.classList.remove("open-sub-menu"));
        var e =
          Array.from(document.querySelectorAll(".has-sub-menu.open")) || [];
        e.length &&
          e.forEach((e) => {
            var t = e.querySelector(".sub-menu");
            t.removeAttribute("style"), e.classList.remove("open");
          });
      }),
      _defineProperty(
        this,
        "bounceMouseenter",
        (t) => (
          (this.mouseEnterHasTimeout = !0),
          (this.mouseEnterTimeout = setTimeout(() => this.mouseenter(t), 250))
        )
      ),
      _defineProperty(this, "setMobileMenu", () => {
        this.toDefaultState(),
          (this.isCurretnDesctopMenu = !1),
          this.cloneLogo ||
            ((this.cloneLogo = this.logo.cloneNode(!0)),
            this.mobileTop.prepend(this.cloneLogo)),
          this.mobileTop.after(this.nav),
          this.submenuTriggersHasListener &&
            this.submenuTriggers &&
            this.submenuTriggers.length &&
            (this.submenuTriggers.forEach((e) => {
              e.removeEventListener("mouseenter", this.bounceMouseenter),
                e.removeEventListener("mouseleave", this.mouseleave);
            }),
            (this.submenuTriggersHasListener = !1));
      }),
      _defineProperty(this, "setDesctopmenu", () => {
        this.toDefaultState(),
          (this.isCurretnDesctopMenu = !0),
          this.logo.after(this.nav),
          !this.submenuTriggersHasListener &&
            this.submenuTriggers &&
            this.submenuTriggers.length &&
            (this.submenuTriggers.forEach((e) => {
              e.addEventListener("mouseenter", this.bounceMouseenter),
                e.addEventListener("mouseleave", this.mouseleave);
            }),
            (this.submenuTriggersHasListener = !0));
      }),
      _defineProperty(
        this,
        "checkScreenSize",
        () => (
          this.calculateMoveTrigger(),
          this.startMarquee(),
          (this.currentSize = document.documentElement.offsetWidth),
          this.currentSize <= this.sizeTrigger && this.isCurretnDesctopMenu
            ? this.setMobileMenu()
            : this.currentSize > this.sizeTrigger && !this.isCurretnDesctopMenu
            ? this.setDesctopmenu()
            : void 0
        )
      ),
      _defineProperty(this, "setConsructorValue", () => {
        (this.header = document.querySelector("header") || null),
          (this.submenuTriggers =
            Array.from(document.querySelectorAll(this.enterTriggerSelector)) ||
            []),
          (this.catalogFilterPanel =
            document.querySelector("aside.sticky-filter-panel") || null),
          (this.catalogParent =
            document.querySelector('[data-catalog-parent="true"].catalog') ||
            null),
          this.header &&
            ((this.desktopParent = this.header.querySelector(".menu") || null),
            (this.mobileParent =
              this.header.querySelector(".mob-menu") || null),
            (this.mobileTop = this.mobileParent
              ? this.mobileParent.querySelector(".top")
              : null),
            (this.logo = this.desktopParent
              ? this.desktopParent.querySelector(".logo")
              : null),
            (this.nav = this.desktopParent
              ? this.desktopParent.querySelector("nav")
              : null),
            (this.search =
              this.header.querySelector("#header-search") || null));
      }),
      _defineProperty(this, "input", (t) => {
        var e = t.target,
          a = e.value,
          s = e.closest(".box"),
          i = s.querySelector(".btn.search-clean") || null,
          n = s.querySelector(".btn.search") || null,
          r = [i, n].filter((e) => e);
        return r.length
          ? a && a.length
            ? (t.target.classList.add("fullfilled"),
              r.forEach((e) => e.classList.add("show")))
            : (t.target.classList.remove("fullfilled"),
              r.forEach((e) => e.classList.remove("show")))
          : null;
      }),
      _defineProperty(this, "inputCheck", (e) => {
        var t = e,
          a = t.value,
          s = t.closest(".box"),
          i = s.querySelector(".btn.search-clean") || null,
          n = s.querySelector(".btn.search") || null,
          r = [i, n].filter((e) => e);
        return r.length
          ? a && a.length
            ? (t.classList.add("fullfilled"),
              r.forEach((e) => e.classList.add("show")))
            : (t.classList.remove("fullfilled"),
              r.forEach((e) => e.classList.remove("show")))
          : null;
      }),
      _defineProperty(this, "cleanSearch", () =>
        setTimeout(() => this.inputCheck(this.search))
      ),
      _defineProperty(this, "checkColorize", () => {
        var e = document.querySelector("[data-header-colorize]") || null;
        if (!e) return null;
        var t = e.getAttribute("data-header-colorize");
        return this.header.classList.add("bg--".concat(t));
      }),
      _defineProperty(this, "hideHeader", () => {
        this.header.classList.add("invisibility");
      }),
      _defineProperty(this, "unhideHeader", () => {
        this.header.classList.remove("invisibility");
      }),
      _defineProperty(this, "calculateMoveTrigger", () => {
        var e =
          document.querySelector(".content-for-layout") ||
          document.querySelector("#wrapper");
        if (!e) return null;
        var t = Array.from(e.children).find((e) => 0 < e.offsetHeight);
        this.moveTrigger = t.offsetHeight || 0;
      }),
      _defineProperty(this, "headWatchingElem", () => {
        try {
          this.header.classList.contains("v-main") ||
            this.header.classList.add("v-main");
          var e = this.header.offsetHeight / 2,
            t = this.headerWatchElem.getBoundingClientRect().top;
          e >= t
            ? (this.header.classList.add("v-main-swow"),
              this.headerWatchElem.classList.add("hide"))
            : (this.header.classList.remove("v-main-swow"),
              this.headerWatchElem.classList.remove("hide"));
        } catch (t) {
          console.log(t);
        }
      }),
      (this.header = null),
      (this.notification = null),
      (this.enterTriggerSelector = ".has-sub-menu"),
      (this.scrollPos = null),
      (this.isScrollDown = !1),
      (this.mouseOnHeader = !1),
      (this.submenuTriggers = []),
      (this.submenuTriggersHasListener = !1),
      (this.currentOpensubMenu = null),
      (this.timeoutSubmenu = null),
      (this.sizeTrigger = 992),
      (this.currentSize = null),
      (this.isCurretnDesctopMenu = !0),
      (this.desktopParent = null),
      (this.mobileParent = null),
      (this.mobileTop = null),
      (this.logo = null),
      (this.cloneLogo = null),
      (this.nav = null),
      (this.isOpenMobileMenu = !1),
      (this.search = null),
      (this.cleanSearchBtn = null),
      (this.catalogParent = null),
      (this.catalogFilterPanel = null),
      (this.catalogFilterPanelState = ""),
      (this.filaterPanelCan = !0),
      (this.mouseEnterTimeout = null),
      (this.mouseEnterHasTimeout = !1),
      (this.moveTrigger = 0),
      (this.headerWatchElem = null);
  }
  init() {
    try {
      this.setConsructorValue(),
        this.checkNotification(),
        this.checkScreenSize(),
        this.startMarquee(),
        this.header &&
          (this.checkColorize(),
          this.header.addEventListener("mouseenter", this.mouseEnter),
          this.header.addEventListener("mouseleave", this.mouseLeave),
          (this.headerWatchElem = document.querySelector(
            "[data-head-watch-elem]"
          )),
          this.headerWatchElem &&
            (this.headWatchingElem(),
            window.addEventListener("scroll", this.headWatchingElem))),
        this.search &&
          (this.inputCheck(this.search),
          this.search.addEventListener("input", this.input),
          this.search.addEventListener("change", this.input),
          (this.cleanSearchBtn =
            this.search.closest(".box").querySelector(".btn.search-clean") ||
            null),
          this.cleanSearchBtn &&
            this.cleanSearchBtn.addEventListener("click", this.cleanSearch)),
        this.submenuTriggers &&
          this.submenuTriggers.length &&
          this.currentSize > this.sizeTrigger &&
          (this.submenuTriggers.forEach((e) => {
            e.addEventListener("mouseenter", this.bounceMouseenter),
              e.addEventListener("mouseleave", this.mouseleave);
          }),
          (this.submenuTriggersHasListener = !0)),
        this.scroll(),
        window.addEventListener("scroll", this.scroll),
        window.addEventListener("resize", this.checkScreenSize),
        document.addEventListener("click", this.click),
        document.addEventListener("hide-header", this.hideHeader),
        document.addEventListener("unhide-header", this.unhideHeader),
        document.addEventListener("close-header-menu", this.closeMobNavMenu),
        document.addEventListener("loadedStyle", this.calculateMoveTrigger);
    } catch (t) {
      console.log(t);
    }
  }
  destroy() {
    try {
      this.isCurretnDesctopMenu || this.setDesctopmenu(),
        this.toDefaultState(),
        this.header &&
          (this.header.removeEventListener("mouseenter", this.mouseEnter),
          this.header.removeEventListener("mouseleave", this.mouseLeave),
          (this.desktopParent = null),
          (this.mobileParent = null),
          (this.mobileTop = null),
          (this.logo = null),
          (this.cloneLogo = null),
          (this.nav = null),
          (this.header = null),
          this.headerWatchElem &&
            (window.removeEventListener("scroll", this.headWatchingElem),
            (this.headerWatchElem = null))),
        this.search &&
          (this.search.removeEventListener("input", this.input),
          this.search.removeEventListener("change", this.input),
          (this.search = null),
          this.cleanSearchBtn &&
            (this.cleanSearchBtn.addEventListener("click", this.cleanSearch),
            (this.cleanSearchBtn = null))),
        this.submenuTriggers &&
          this.submenuTriggers.length &&
          this.submenuTriggersHasListener &&
          (this.submenuTriggers.forEach((e) => {
            e.removeEventListener("mouseenter", this.bounceMouseenter),
              e.removeEventListener("mouseleave", this.mouseleave);
          }),
          (this.submenuTriggers = [])),
        this.catalogParent && (this.catalogParent = null),
        this.catalogFilterPanel && (this.catalogFilterPanel = null),
        window.removeEventListener("scroll", this.scroll),
        window.removeEventListener("resize", this.checkScreenSize),
        document.removeEventListener("click", this.click),
        document.removeEventListener("hide-header", this.hideHeader),
        document.removeEventListener("unhide-header", this.unhideHeader),
        document.removeEventListener("close-header-menu", this.closeMobNavMenu),
        document.removeEventListener("loadedStyle", this.calculateMoveTrigger),
        (this.scrollPos = null),
        (this.currentSize = null),
        (this.isOpenMobileMenu = !1),
        (this.submenuTriggersHasListener = !1);
    } catch (t) {
      console.log(t);
    }
  }
}
class BagControll {
  constructor() {
    var e = this;
    _defineProperty(this, "callUpdatePageBagSection", () =>
      this.updateBag(!0, this.cartPageSection)
    ),
      _defineProperty(this, "scrollMainElem", () => {
        try {
          var e;
          if (!this.bagMainElem) return null;
          var t = this.bagMainElem.offsetHeight,
            a =
              (null ===
                (e = document.querySelector("[data-bag] .bag-box-main-fits")) ||
              void 0 === e
                ? void 0
                : e.getBoundingClientRect().top) || 0,
            s = document.querySelector(".btn[data-open-bag-fits]");
          a > t ? s.classList.remove("hide") : s.classList.add("hide");
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(this, "loadingSwitch", function () {
        var e =
          !!(0 < arguments.length && arguments[0] !== void 0) && arguments[0];
        try {
          var t = document.querySelector(".section-bag .bag-box");
          if (!t) return null;
          if (e) return t.classList.add("loading");
          t.classList.remove("loading");
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(this, "updateCartPage", (e) => {
        try {
          var t = -1 != window.location.href.indexOf("/cart");
          if (!t || !e) return null;
          var a = ["#main-cart-footer .js-contents"];
          a.forEach((t) => {
            var a = document.querySelector(t),
              s = e.querySelector(t);
            a && s && (a.innerHTML = s.innerHTML);
          });
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(
        this,
        "updateBag",
        _asyncToGenerator(function* () {
          var t =
              !!(0 < arguments.length && arguments[0] !== void 0) &&
              arguments[0],
            a =
              1 < arguments.length && arguments[1] !== void 0
                ? arguments[1]
                : null;
          try {
            e.loadingSwitch(!0);
            var s = window.location.href;
            fetch(s)
              .then((e) => e.text())
              .then((s) => {
                var i = new DOMParser(),
                  n = i.parseFromString(s, "text/html");
                e.updateCartPage(n);
                var r = n.querySelector("[data-bag] .bag-box"),
                  o = n.querySelector("[data-open-bag] .cart-count"),
                  l = document.querySelector("[data-bag] .bag-box"),
                  d = document.querySelector("[data-open-bag] .cart-count");
                r && l && (l.innerHTML = r.innerHTML),
                  o && d && (d.innerHTML = o.innerHTML),
                  requestAnimationFrame(initLazy),
                  t && a
                    ? requestAnimationFrame(() => e.updateBagfits(a))
                    : requestAnimationFrame(() => e.updateBagfits()),
                  requestAnimationFrame(() => {
                    e.bagMainElem &&
                      e.bagMainElem.removeEventListener(
                        "scroll",
                        e.scrollMainElem
                      ),
                      (e.bagMainElem =
                        document.querySelector("[data-bag] .bag-box-main") ||
                        null),
                      e.bagMainElem &&
                        e.bagMainElem.addEventListener(
                          "scroll",
                          e.scrollMainElem
                        );
                  });
              })
              .catch((t) => {
                console.log(t);
              })
              .finally(e.loadingSwitch);
          } catch (t) {
            console.log(t);
          }
        })
      ),
      _defineProperty(
        this,
        "removeCartItem",
        (function () {
          var t = _asyncToGenerator(function* (t) {
            try {
              var a = t.getAttribute("data-line-id");
              if (!a) return null;
              e.loadingSwitch(!0);
              var s = { id: a, quantity: 0 };
              fetch(window.Shopify.routes.root + "cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(s),
              })
                .then((e) => e.json())
                .catch((e) => {
                  console.error("Error:", e);
                })
                .finally(e.updateBag);
            } catch (t) {
              console.log(t);
            }
          });
          return function (e) {
            return t.apply(this, arguments);
          };
        })()
      ),
      _defineProperty(this, "openBag", () => {
        try {
          var e = -1 != window.location.href.indexOf("/cart");
          if (e) return null;
          if (this.bagIsOpen) return null;
          var t = document.querySelector("[data-bag]");
          if (!t) return null;
          disableScroll(),
            t.classList.add("display"),
            setTimeout(() => {
              t.classList.add("show"), (this.bagIsOpen = !0);
            });
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(this, "openBagAnim", () =>
        requestAnimationFrame(this.openBag)
      ),
      _defineProperty(this, "createFitsCard", function () {
        var t =
            0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : [],
          a =
            1 < arguments.length && arguments[1] !== void 0
              ? arguments[1]
              : null,
          s =
            2 < arguments.length && arguments[2] !== void 0
              ? arguments[2]
              : null;
        try {
          if (!t.length) return null;
          var i = t
              .map((e) => {
                var t,
                  {
                    id: a,
                    featured_image: s,
                    url: i,
                    images: o = [],
                    title: n,
                    price: r,
                    variants: l = [],
                  } = e,
                  d = (r / 100).toFixed(2);
                d = d.replace(/(\.00)$/, "");
                var c = d.split("."),
                  u = c[0] + (c[1] ? "," + c[1] : ""),
                  h =
                    null ===
                      (t = l.find((e) => {
                        var { available: t = !1 } = e;
                        return t;
                      })) || void 0 === t
                      ? void 0
                      : t.id,
                  g = o.find((e) => e && e != s);
                return '<article id="product_'
                  .concat(
                    a,
                    '" class="product-card">\n    <div class="preview">\n    <img class="lazyWebp " width="360" height="479" data-src="'
                  )
                  .concat(s, '" data-webp="')
                  .concat(s, '" data-retina="')
                  .concat(s, '" data-webp-retina="')
                  .concat(
                    s,
                    '" alt="photo" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==">\n        <div class="action">\n        <a class="oversize" href="'
                  )
                  .concat(
                    i,
                    '"></a>\n              \n        </div>\n        <img class="lazyWebp " width="360" height="479" data-src="'
                  )
                  .concat(g, '" data-webp="')
                  .concat(g, '" data-retina="')
                  .concat(g, '" data-webp-retina="')
                  .concat(
                    g,
                    '" alt="photo" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==">\n    </div>\n    <div class="info">\n        <div class="info--top">\n                <div title="'
                  )
                  .concat(n, '" class="name">')
                  .concat(
                    n,
                    '</div>\n      \n<div class="\nprice ">\n<div class="price__container"><div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span>\n      <span class="price-item price-item--regular">\n        '
                  )
                  .concat(
                    u,
                    " ",
                    Shopify.currency.active,
                    '\n      </span><span class="money">$'
                  )
                  .concat(
                    u,
                    "</span></div></div></div>\n        </div>\n\n    </div>\n</article>"
                  );
              })
              .join(""),
            n = s
              ? s
              : document.querySelector("[data-bag] .bag-box-main-fits-list");
          if (!n) return null;
          (n.innerHTML = i),
            requestAnimationFrame(() => {
              initLazy(),
                e.scrollMainElem(),
                document.querySelector("[data-fits]") &&
                  document
                    .querySelector("[data-fits]")
                    .classList.remove("loading"),
                a && a.classList.remove("loading"),
                document.dispatchEvent(
                  new CustomEvent("collection-wishlist-btn-update")
                );
            });
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(
        this,
        "updateBagfits",
        _asyncToGenerator(function* () {
          var t =
              !!(0 < arguments.length && arguments[0] !== void 0) &&
              arguments[0],
            a = document.querySelector("[data-fits]");
          try {
            if (!a) return null;
            a.classList.add("loading");
            var s = a.getAttribute("data-fits-id");
            if (!s) return null;
            var i = s.split(","),
              n = new Set(i),
              r = [...n].map((e) => e),
              o = yield Promise.all(
                r.map((e) =>
                  fetch(
                    window.Shopify.routes.root +
                      "recommendations/products.json?product_id=".concat(
                        e,
                        "&limit=2&intent=related"
                      )
                  )
                    .then((e) => e.json())
                    .then((e) => {
                      var { products: t } = e;
                      return t;
                    })
                    .catch((t) => (console.log(t), null))
                )
              );
            if (o && o.length) {
              var l = [];
              o.forEach((e) => {
                e && e.length && l.push(...e);
              });
              var d = new Set(
                  l.map((e) => {
                    var { id: t } = e;
                    return t;
                  })
                ),
                c = [...d]
                  .map((e) =>
                    l.find((t) => {
                      var { id: a } = t;
                      return a === e;
                    })
                  )
                  .filter((e) => e);
              if (!t) {
                var u = document.querySelector(
                  "[data-bag] .bag-box-main-fits-list"
                );
                e.createFitsCard(c, u);
              } else e.createFitsCard(c, a, t);
            } else a.classList.remove("loading");
          } catch (t) {
            a.classList.remove("loading");
          }
        })
      ),
      _defineProperty(this, "closeBag", () => {
        try {
          if (!this.bagIsOpen) return null;
          var e = document.querySelector("[data-bag]");
          if (!e) return null;
          this.closeFits(),
            e.classList.remove("show"),
            setTimeout(() => {
              e.classList.remove("display"),
                (this.bagIsOpen = !1),
                enableScroll();
            }, this.transDelay);
        } catch (e) {
          console.log(e);
        }
      }),
      _defineProperty(this, "closeBagAnim", () =>
        requestAnimationFrame(this.closeBag)
      ),
      _defineProperty(this, "openFits", (e) => {
        try {
          var t = document.querySelector("[data-bag] .bag-box-main-fits"),
            a = t ? t.getBoundingClientRect().top : 0,
            s = document.querySelector("[data-bag] .bag-box-main"),
            i = s ? s.scrollTop : 0,
            n = document.querySelector("[data-bag] .bag-box-head"),
            r = n ? n.offsetHeight : 0;
          s.scrollTo({ top: a + i - r, behavior: "smooth" });
        } catch (e) {
          console.log(e);
        }
      }),
      _defineProperty(this, "closeFits", () => {
        try {
          if (!this.fitsIsOpen) return null;
          var e = document.querySelector("[data-fits]");
          if (!e) return null;
          var t = document.querySelector("[data-open-bag-fits]");
          t.classList.remove("hide"),
            e.classList.remove("show"),
            setTimeout(() => {
              e.classList.remove("display"), (this.fitsIsOpen = !1);
            }, this.transDelay);
        } catch (e) {
          console.log(e);
        }
      }),
      _defineProperty(this, "click", (t) => {
        var e = t.target.closest("[data-open-bag]"),
          a =
            t.target.closest("[data-close-bag]") ||
            t.target.hasAttribute("data-bag"),
          s = t.target.closest("[data-open-bag-fits]"),
          i = t.target.closest("[data-close-bag-fits]"),
          n = t.target.closest('[data-bag-action="remove-item"]');
        return e
          ? this.openBag()
          : a
          ? this.closeBag()
          : s
          ? this.openFits(s)
          : i
          ? this.closeFits()
          : n
          ? this.removeCartItem(n)
          : void 0;
      }),
      (this.bagIsOpen = !1),
      (this.fitsIsOpen = !1),
      (this.transDelay = 300),
      (this.cartPageSection = null),
      (this.bagMainElem = null);
  }
  init() {
    (this.bagMainElem =
      document.querySelector("[data-bag] .bag-box-main") || null),
      this.bagMainElem &&
        this.bagMainElem.addEventListener("scroll", this.scrollMainElem),
      (this.cartPageSection =
        document.querySelector('[data-cart-page-fits="true"]') || null),
      this.cartPageSection ||
        setTimeout(() => {
          this.updateBagfits(), this.scrollMainElem();
        }),
      this.cartPageSection &&
        (setTimeout(() => {
          this.updateBagfits(this.cartPageSection), this.scrollMainElem();
        }),
        document.addEventListener(
          "bag-page-update",
          this.callUpdatePageBagSection
        )),
      document.addEventListener("click", this.click),
      document.addEventListener("bag-open", this.openBagAnim),
      document.addEventListener("bag-close", this.closeBagAnim),
      document.addEventListener("bag-update", this.updateBag);
  }
  destroy() {
    this.bagMainElem &&
      this.bagMainElem.removeEventListener("scroll", this.scrollMainElem),
      document.removeEventListener("click", this.click),
      document.removeEventListener("bag-open", this.openBagAnim),
      document.removeEventListener("bag-close", this.closeBagAnim),
      document.removeEventListener("bag-update", this.updateBag),
      this.cartPageSection &&
        document.removeEventListener(
          "bag-page-update",
          this.callUpdatePageBagSection
        );
  }
}
class SearchControll {
  constructor() {
    var e = this;
    _defineProperty(this, "openSearch", () => {
      if (this.searchIsOpen) return null;
      var e = document.querySelector("[data-search]");
      return e
        ? void (e.classList.add("display"),
          disableScroll(),
          setTimeout(() => {
            e.classList.add("show"), (this.searchIsOpen = !0);
          }))
        : null;
    }),
      _defineProperty(this, "closeSearch", () => {
        if (!this.searchIsOpen) return null;
        var e = document.querySelector("[data-search]");
        return e
          ? void (e.classList.remove("show"),
            setTimeout(() => {
              e.classList.remove("display"),
                (this.searchIsOpen = !1),
                enableScroll();
            }, this.delay))
          : null;
      }),
      _defineProperty(this, "loaading", function () {
        var t =
          !!(0 < arguments.length && arguments[0] !== void 0) && arguments[0];
        e.loading = t;
        var a = t ? "add" : "remove",
          s = [
            document.querySelector("[data-search] .search-box-action") || null,
            document.querySelector("[data-search] .search-box-result") || null,
          ].filter((e) => e);
        return s.length
          ? void (s.forEach((e) => e.classList[a]("loading")),
            document.dispatchEvent(
              new CustomEvent("collection-wishlist-btn-update")
            ))
          : null;
      }),
      _defineProperty(this, "loaadingMoreOn", function () {
        var e =
            !!(0 < arguments.length && arguments[0] !== void 0) && arguments[0],
          t = e ? "add" : "remove",
          a = [
            document.querySelector("[data-search] .search-box-result") || null,
          ].filter((e) => e);
        return a.length
          ? void (a.forEach((e) => e.classList[t]("loading")),
            document.dispatchEvent(
              new CustomEvent("collection-wishlist-btn-update")
            ))
          : null;
      }),
      _defineProperty(this, "write", (t) => {
        this.throttlin &&
          (clearTimeout(this.throttlin), (this.throttlin = null));
        var e = t.target.value.trim(),
          a = document.querySelector("[data-reset-search]") || null;
        e && e.length
          ? (a && a.classList.add("show"),
            (this.throttlin = setTimeout(() => {
              this.form && this.form.dispatchEvent(new Event("submit"));
            }, this.writeDelay)))
          : (a && a.classList.remove("show"), this.closeResult());
      }),
      _defineProperty(this, "openResult", () => {
        if (this.resultIsopen) return null;
        var e = document.querySelector("[data-search] .search-box-result");
        return e
          ? void (e.classList.add("display"),
            setTimeout(() => {
              e.classList.add("show"), (this.resultIsopen = !0);
            }))
          : null;
      }),
      _defineProperty(this, "closeResult", () => {
        if ((this.readQuery() && this.cleanQuery(), !this.resultIsopen))
          return null;
        var e = document.querySelector("[data-search] .search-box-result");
        return e
          ? void (e.classList.remove("show"),
            this.cleanDOMElements(),
            setTimeout(() => {
              e.classList.remove("display"), (this.resultIsopen = !1);
            }, this.delay))
          : null;
      }),
      _defineProperty(this, "loadMore", (e) => {
        try {
          var t = e.dataset.href;
          if (!t) return null;
          this.loaadingMoreOn(!0),
            fetch(t)
              .then((e) => e.text())
              .then((e) => {
                var a = new DOMParser().parseFromString(e, "text/html"),
                  s = a.querySelector("[data-search-result] .product-list");
                if (!s) return null;
                var i = Array.from(s.children) || [];
                if (!i.length) return null;
                var n = document.querySelector(
                  "[data-search-result] .product-list"
                );
                n.append(...i), requestAnimationFrame(initLazy);
                var r = a.querySelector("[data-search-load-more]");
                if (r) {
                  var o = r.querySelector("[data-search-load-more-btn]"),
                    l = o.dataset.href;
                  if (l !== t) {
                    var d = document.querySelector("[data-search-load-more]");
                    (d.innerHTML = r.innerHTML),
                      requestAnimationFrame(() =>
                        this.loadnextPageWatcher(
                          document.querySelector("[data-search-load-more-btn]")
                        )
                      );
                  }
                } else {
                  var c = document.querySelector("[data-search-load-more]");
                  c && c.remove();
                }
              })
              .finally(() => this.loaadingMoreOn());
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(this, "handleIntersection", (e, t) => {
        e.forEach((e) => {
          e.isIntersecting && (this.loadMore(e.target), t.disconnect());
        });
      }),
      _defineProperty(this, "loadnextPageWatcher", (e) => {
        var t = { root: null, rootMargin: "0px", threshold: 0 },
          a = new IntersectionObserver(this.handleIntersection, t);
        a.observe(e);
      }),
      _defineProperty(this, "searchQuery", () => {
        try {
          var e = this.readQuery();
          if (!e) return this.searchIsOpen ? this.closeSearch() : null;
          console.log("searchQuery", e, this.input),
            (this.input.value = e),
            this.input.dispatchEvent(new Event("input")),
            this.searchIsOpen || this.openSearch();
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(this, "writeQuery", (e) => {
        try {
          if (this.readQuery() == e) return null;
          var t = new URL(window.location);
          t.searchParams.set(this.queryName, e),
            history.pushState(null, "", t.toString());
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(this, "cleanQuery", () => {
        try {
          var e = new URL(window.location);
          e.searchParams.delete(this.queryName);
          var t = e.toString();
          history.pushState(null, "", t);
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(this, "readQuery", () => {
        try {
          var e = window.location.search,
            t = new URLSearchParams(e);
          return t.get(this.queryName);
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(this, "submit", (t) => {
        try {
          t.preventDefault(), console.log("submit");
          var e = t.target.querySelector('input[name="q"][type="search"]'),
            a = e.value;
          if (!a) return null;

          const marketUrl = window.location.pathname.startsWith("/en-")
            ? "/" + window.location.pathname.split("/")[1]
            : "";

          this.writeQuery(a),
            this.cleanDOMElements(),
            this.loaading(!0),
            fetch(
              `${marketUrl}/search?q=${a}&type=product&options[prefix]=last`
            )
              .then((e) => e.text())
              .then((e) => {
                var t = new DOMParser().parseFromString(e, "text/html"),
                  a = ["data-search-total", "data-search-result"];
                a.forEach((e) => {
                  var a = document.querySelector("[".concat(e, "]")),
                    s = t.querySelector("[".concat(e, "]"));
                  a.innerHTML = s.innerHTML;
                }),
                  requestAnimationFrame(() => {
                    this.openResult(), initLazy();
                  });
                var s =
                  document.querySelector("[data-search-load-more-btn]") || null;
                s && this.loadnextPageWatcher(s);
              })
              .finally(() => this.loaading());
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(this, "resetForm", (e) => {
        e.classList.remove("show"), this.closeResult();
      }),
      _defineProperty(this, "cleanDOMElements", () => {
        var e = document.querySelector("[data-search-total]");
        e && (e.textContent = "");
        var t = document.querySelector("[data-search-result]");
        t && (t.innerHTML = "");
      }),
      _defineProperty(this, "suggest", (e) => {
        var t = e.getAttribute("data-search-suggest");
        if (!t) return null;
        this.input.value = t;
        var a = document.querySelector("[data-reset-search]");
        a && a.classList.add("show"),
          this.form && this.form.dispatchEvent(new Event("submit"));
      }),
      _defineProperty(this, "click", (t) => {
        var e = t.target.closest("[data-open-search]"),
          a = t.target.closest("[data-close-search]"),
          s = t.target.hasAttribute("data-search"),
          i = t.target.closest("[data-reset-search]"),
          n = t.target.closest("[data-search-suggest]");
        return e
          ? this.openSearch()
          : a || s
          ? this.closeSearch()
          : i
          ? this.resetForm(i)
          : n
          ? this.suggest(n)
          : void 0;
      }),
      (this.form = null),
      (this.input = null),
      (this.searchIsOpen = !1),
      (this.delay = 300),
      (this.writeDelay = 1e3),
      (this.throttlin = null),
      (this.loading = !1),
      (this.resultIsopen = !1),
      (this.queryName = "searchq");
  }
  init() {
    (this.form = document.querySelector("form[data-search-form]")),
      this.form && this.form.addEventListener("submit", this.submit),
      (this.input = document.querySelector("[data-search-input]")),
      this.input && this.input.addEventListener("input", this.write),
      document.addEventListener("click", this.click),
      this.searchQuery(),
      window.addEventListener("popstate", this.searchQuery);
  }
  destroy() {
    this.form && this.form.removeEventListener("submit", this.submit),
      this.input && this.input.removeEventListener("input", this.write),
      document.removeEventListener("click", this.click);
  }
}
class LogControll {
  constructor() {
    _defineProperty(this, "open", () => {
      document.dispatchEvent(new CustomEvent("close-header-menu"));
      var e = document.querySelector("[data-log]");
      return e
        ? void (e.classList.add("display"),
          disableScroll(),
          setTimeout(() => {
            e.classList.add("show"), this.fullFilledCheck();
          }))
        : null;
    }),
      _defineProperty(this, "close", () => {
        var e = document.querySelector("[data-log]");
        return e
          ? void (e.classList.remove("show"),
            setTimeout(() => {
              enableScroll(), e.classList.remove("display");
            }, 300))
          : null;
      }),
      _defineProperty(this, "fullFilledCheck", () => {
        var e = document.querySelector("[data-log]"),
          t = Array.from(e.querySelectorAll(".obx")) || [],
          a = t.filter((e) => {
            var t = e.querySelector("input");
            return t.value && t.value.length;
          });
        a.length && a.forEach((e) => e.classList.add("fullfiled"));
      }),
      _defineProperty(this, "checkInput", (t) => {
        var e = t.target,
          a = e.closest(".obx");
        return a ? a.classList.add("fullfiled") : null;
      }),
      _defineProperty(this, "checkInputBlur", (t) => {
        var e = t.target,
          a = e.closest(".obx");
        if (!a) return null;
        var s = e.value && e.value.length;
        return s
          ? a.classList.add("fullfiled")
          : a.classList.remove("fullfiled");
      }),
      _defineProperty(this, "showPass", (e) => {
        try {
          var t = e.closest(".obx"),
            a = t.querySelector(".action"),
            s = t.querySelector("input");
          (s.type = "text"), a.classList.add("hide");
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(this, "hidePass", (e) => {
        try {
          var t = e.closest(".obx"),
            a = t.querySelector(".action"),
            s = t.querySelector("input");
          (s.type = "password"), a.classList.remove("hide");
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(this, "openReg", (e) => {
        var t = e.closest("[data-log]");
        t.classList.add("reg");
      }),
      _defineProperty(this, "openLog", (e) => {
        var t = e.closest("[data-log]");
        t.classList.remove("reg");
      }),
      _defineProperty(this, "click", (t) => {
        var e = t.target.closest("[data-open-log]"),
          a = t.target.closest("[data-close-log]"),
          s = t.target.classList.contains("section-log"),
          i = t.target.closest("[data-password-show]"),
          n = t.target.closest("[data-password-hide]"),
          r = t.target.closest("[data-log-open-reg]"),
          o = t.target.closest("[data-log-open-login]");
        return e
          ? this.open()
          : a || s
          ? this.close()
          : i
          ? this.showPass(i)
          : n
          ? this.hidePass(n)
          : r
          ? this.openReg(r)
          : o
          ? this.openLog(o)
          : void 0;
      }),
      (this.inputs = []);
  }
  init() {
    (this.inputs =
      Array.from(document.querySelectorAll("[data-log] .obx input")) || []),
      this.inputs.length &&
        this.inputs.forEach((e) => {
          e.addEventListener("focus", this.checkInput),
            e.addEventListener("blur", this.checkInputBlur);
        }),
      document.addEventListener("click", this.click);
  }
  destroy() {
    document.removeEventListener("click", this.click),
      this.inputs.length &&
        this.inputs.forEach((e) => {
          e.removeEventListener("focus", this.checkInput),
            e.removeEventListener("blur", this.checkInputBlur);
        });
  }
}
class FooterControll {
  constructor() {}
  hideFooter() {
    var e = document.querySelector('[data-footer-hide="true"]');
    if (!e) return null;
    var t = document.querySelector("footer");
    t && (t.style.display = "none");
  }
  init() {
    this.hideFooter();
  }
  destroy() {}
}
var goAwayFromPage = () => {
  var e = document.querySelector(".afterload") || null;
  if (e) return e.classList.add("show");
};
class WishlistApi {
  constructor() {
    var e = this;
    _defineProperty(this, "getUUID", () => {
      try {
        for (var e, t = document.cookie.split(";"), a = 0; a < t.length; a++)
          if (((e = t[a].trim()), e.startsWith(this.coockieName + "=")))
            return e.substring(this.coockieName.length + 1);
        return null;
      } catch (t) {
        return console.log(t), null;
      }
    }),
      _defineProperty(this, "setUUID", (e) => {
        try {
          var t = new Date();
          t.setTime(t.getTime() + 31536000000);
          var a = "expires=" + t.toUTCString();
          document.cookie = this.coockieName + "=" + e + ";" + a + ";path=/";
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(this, "deleteUUID", () => {
        try {
          var e = new Date("Thu, 01 Jan 1970 00:00:00 GMT"),
            t = "expires=" + e.toUTCString();
          (document.cookie = this.coockieName + "=;" + t + ";path=/"),
            (this.uuid = null);
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(
        this,
        "synhronizeWishlist",
        _asyncToGenerator(function* () {
          try {
            var t = new URL("".concat(e.baseURL, "/sync_products")),
              a = { uuid: e.uuid, customer_id: e.shopifyCustomerId };
            return fetch(t, {
              method: "POST",
              headers: e.headers,
              body: JSON.stringify(a),
            })
              .then((e) => e.json())
              .then((t) => {
                var { message: a } = t;
                e.deleteUUID();
              })
              .catch((e) => console.log(e));
          } catch (t) {
            console.log(t);
          }
        })
      ),
      _defineProperty(this, "cardWishlistCard", function () {
        var e,
          {
            available: t,
            current_variant_id: a,
            featured_image: s,
            id: u = null,
            options: h = [],
            price: i,
            price_max: n,
            price_min: r,
            title: g = "",
            url: p = "#",
            variants: o,
            compare_at_price: l,
            compare_at_price_max: d,
            compare_at_price_min: c,
          } = 0 < arguments.length && arguments[0] !== void 0
            ? arguments[0]
            : {};
        if (!u) return "";
        var m = s
            ? '<img width="170" height="226" src="'.concat(s, '" alt="photo">')
            : "",
          f =
            g || p
              ? '<a href="'
                  .concat(p, '" class="section-wishlist-card-name">')
                  .concat(g, "</a>")
              : "",
          v = () => {
            if (!h.length) return "";
            var e = h.map((e) =>
                _objectSpread(
                  _objectSpread({}, e),
                  {},
                  {
                    values: e.values.map((t) => {
                      var a = o.find(
                        (a) =>
                          a.title === t || a["option".concat(e.position)] == t
                      );
                      return a ? a : t;
                    }),
                  }
                )
              ),
              t = "",
              s = e
                .map((e) => {
                  var { name: s, position: i, values: n = [] } = e,
                    r = s
                      ? '<div class="section-wishlist-card-options-name">'.concat(
                          s,
                          "</div>"
                        )
                      : "",
                    o = n
                      .map((e) => {
                        e.id == a && (t = e["option".concat(i)]);
                        var s = e.id == a ? 'class="active"' : "",
                          n =
                            null !== e && void 0 !== e && e.available
                              ? ""
                              : 'data-disabled="true"';
                        return "<li "
                          .concat(n, " ")
                          .concat(s, ' data-product-id="')
                          .concat(e.id, '" data-select-value="')
                          .concat(e["option".concat(i)], '">')
                          .concat(e["option".concat(i)], "</li>");
                      })
                      .join("");
                  return "<li>\n                                "
                    .concat(
                      r,
                      '\n                                <div class="section-wishlist-card-options-val">\n                                    <div class="seclect">\n                                        <ul data-lenis-prevent class="list">\n                                            '
                    )
                    .concat(
                      o,
                      '\n                                        </ul>\n                                        <div data-select-trigger="" class="trigger">\n                                            <label for="'
                    )
                    .concat(
                      s + i,
                      '">\n                                                <input id="'
                    )
                    .concat(s + i, '" placeholder="')
                    .concat(s, '" type="text" value="')
                    .concat(
                      t,
                      '">\n                                            </label>\n                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="4" viewBox="0 0 8 4" fill="none">\n                                                <path d="M4 4L8 0H0L4 4Z" fill="#262626"></path>\n                                            </svg>\n                                        </div>\n                \n                                    </div>\n                                </div>\n                            </li>'
                    );
                })
                .join();
            return s;
          },
          y = () => {
            var e,
              t,
              a =
                (null === (e = shopitranslates) || void 0 === e
                  ? void 0
                  : e.price) || "Price",
              s =
                (null === (t = shopitranslates) || void 0 === t
                  ? void 0
                  : t.money) || "...",
              o = [i, n, r, l, d, c].filter((e) => e && 0 < e),
              u = Math.max(...o),
              h = Math.min(...o),
              g =
                u === h
                  ? shopifyFormatedPrice(u, "{{amount}} ".concat(s))
                  : shopifyFormatedPrice(h, "{{amount}} ".concat(s)),
              p =
                u === h
                  ? ""
                  : '<div class="price price-min">'.concat(
                      shopifyFormatedPrice(u, "{{amount}} ".concat(s)),
                      "</div>"
                    ),
              m =
                u === h
                  ? ""
                  : '<span class="price price-min money">$'.concat(
                      shopifyFormatedPrice(u, "{{amount}} ".concat(s)),
                      "</span>"
                    );
            return '\n      <li>\n                                <div class="section-wishlist-card-options-name">'
              .concat(
                a,
                '</div>\n                                <div class="section-wishlist-card-options-val">\n                                    '
              )
              .concat(
                p,
                '\n                                    <div class="price">'
              )
              .concat(
                g,
                '</div>\n                                    <br>\n                                    <div class="price-hide">\n                                       '
              )
              .concat(
                m,
                '\n                                    <span class="money">$'
              )
              .concat(
                g,
                "</span>\n                                    </div>\n                                   \n                                </div>\n                            </li>\n      "
              );
          },
          b =
            (null === (e = shopitranslates) || void 0 === e
              ? void 0
              : e.addtocard) || "",
          L = t ? "" : 'class="disabled"';
        return '<li class="section-wishlist-card '
          .concat(
            t ? "" : "disabled",
            '">\n                    <div class="section-wishlist-card-image">\n                        '
          )
          .concat(
            m,
            '\n                    </div>\n                    <div class="section-wishlist-card-content">\n                        <button data-wishlist-remove-trigger="true" data-product-id="'
          )
          .concat(u, '" data-product-variant-id="')
          .concat(
            a,
            '" class="btn section-wishlist-card-remove" data-wishlist-remove aria-label="clean" type="button">\n                             <svg class="close-animate-svg" xmlns="http://www.w3.org/2000/svg" width="15"\n                        height="15" viewBox="0 0 15 15" fill="none">\n                        <path fill-rule="evenodd" clip-rule="evenodd"\n                            d="M0.576394 14.4438C0.263966 14.1314 0.262035 13.623 0.572079 13.3082L6.30917 7.48354C6.61921 7.16876 7.12382 7.16684 7.43625 7.47925C7.74868 7.79166 7.75061 8.3001 7.44057 8.61488L1.70348 14.4395C1.39344 14.7543 0.888822 14.7562 0.576394 14.4438Z"\n                            fill="#262626" />\n                        <path data-path-change="M13.28 1.54483C12.9676 1.23242 12.463 1.23433 12.1529 1.54911L6.88799 6.89441C6.57795 7.20919 6.57988 7.71762 6.89231 8.03003C7.20473 8.34244 7.70935 8.34053 8.01939 8.02575L13.2843 2.68045C13.5944 2.36567 13.5925 1.85724 13.28 1.54483Z" fill-rule="evenodd" clip-rule="evenodd"\n                            d="M13.2801 1.54486C12.9677 1.23245 12.4631 1.23436 12.153 1.54914L8.62334 5.13269C8.3133 5.44747 8.31523 5.9559 8.62766 6.26831C8.94009 6.58073 9.4447 6.57881 9.75474 6.26403L13.2844 2.68048C13.5945 2.3657 13.5925 1.85727 13.2801 1.54486Z"\n                            fill="#262626"/>\n                        <path fill-rule="evenodd" clip-rule="evenodd"\n                            d="M13.4522 14.3925C13.1433 14.7084 12.6387 14.7122 12.3251 14.4009L0.564443 2.72714C0.250868 2.41589 0.247065 1.90746 0.55595 1.59155C0.864834 1.27563 1.36944 1.27186 1.68301 1.58312L13.4437 13.2569C13.7573 13.5682 13.7611 14.0766 13.4522 14.3925Z"\n                            fill="#262626" />\n                    </svg>\n                        </button>\n                        '
          )
          .concat(
            f,
            '\n                        <ul class="section-wishlist-card-options">\n                          '
          )
          .concat(v(), "\n                          ")
          .concat(
            y(),
            '\n                        </ul>\n                        <form data-action="addToCard" novalidate="" class="section-wishlist-card-action">\n                            <div data-updateble="" class="form-data">\n                                <input type="text" name="quantity" value="1" style="display: none;">\n                                <input type="text" name="id" value="'
          )
          .concat(
            a,
            '" style="display: none;">\n                            </div>\n                            <button '
          )
          .concat(L, ' aria-lable="')
          .concat(
            b,
            '" type="submit">\n                                <div class="ico"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">\n                                        <g clip-path="url(#clip0_2885_10216)">\n                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.7721 3.07331H4.3386C4.41368 2.71542 4.55141 2.32516 4.78128 1.96713C5.20127 1.31295 5.9215 0.788513 7.0002 0.788513C8.07888 0.788513 8.79911 1.31295 9.21911 1.96713C9.44897 2.32516 9.58671 2.71542 9.66179 3.07331H10.2283C11.0589 3.07331 11.7679 3.67353 11.905 4.49277L13.0274 11.2013C13.2009 12.2379 12.4017 13.1819 11.3507 13.1819H7.0002H2.64964C1.59871 13.1819 0.799522 12.2379 0.97295 11.2013L2.09541 4.49277C2.23248 3.67353 2.94148 3.07331 3.7721 3.07331ZM7.0002 11.7819H11.3507C11.5362 11.7819 11.6772 11.6153 11.6466 11.4324L10.5242 4.7238C10.5 4.57923 10.3749 4.47331 10.2283 4.47331H9.03753H7.0002H7.00019H4.96286H3.7721C3.62552 4.47331 3.50041 4.57923 3.47622 4.7238L2.35376 11.4324C2.32315 11.6153 2.46418 11.7819 2.64964 11.7819H7.0002ZM7.00019 3.07331H7.0002H8.21063C8.16712 2.9522 8.1112 2.83281 8.04101 2.72349C7.8498 2.42567 7.55137 2.18851 7.00019 2.18851C6.44901 2.18851 6.15058 2.42567 5.95937 2.72349C5.88919 2.83281 5.83327 2.9522 5.78976 3.07331H7.00019Z" fill="white"></path>\n                                        </g>\n                                        <defs>\n                                            <clipPath id="clip0_2885_10216">\n                                                <rect width="14" height="14" fill="white"></rect>\n                                            </clipPath>\n                                        </defs>\n                                    </svg></div><span>'
          )
          .concat(
            b,
            "</span>\n                            </button>\n                        </form>\n                    </div>\n                </li> "
          );
      }),
      _defineProperty(this, "parsedHTMLWishlistCards", (e) => {
        var { parent: t = null, products: a = [] } = e;
        try {
          if (!t) return null;
          var s = t.querySelector(".full-state"),
            i = s.querySelector(".section-wishlist-list");
          if (!a.length) return null;
          var n = a.map(this.cardWishlistCard).join("");
          i.insertAdjacentHTML("beforeEnd", n),
            requestAnimationFrame(() => {
              document.dispatchEvent(new CustomEvent("hoverclass-reinit")),
                s.classList.add("show"),
                this.lastLoading && t.classList.remove("loading");
            });
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(
        this,
        "getWishlistGuest",
        (function () {
          var t = _asyncToGenerator(function* (t) {
            var a =
              1 < arguments.length && arguments[1] !== void 0
                ? arguments[1]
                : new URL("".concat(e.baseURL, "/products/guest"));
            try {
              t.classList.add("loading"), (e.lastLoading = !1);
              var s = { uuid: e.uuid };
              Object.keys(s).forEach((e) => a.searchParams.append(e, s[e])),
                fetch(a, { method: "GET", headers: e.headers })
                  .then((e) => e.json())
                  .then(
                    (function () {
                      var a = _asyncToGenerator(function* (a) {
                        var {
                          data: s = [],
                          next_page_url: i = null,
                          current_page: n = 1,
                        } = a;
                        if (!s.length && 1 == n)
                          return (
                            t.classList.remove("loading"), e.showEmptyBlock(t)
                          );
                        if (!s.length) return null;
                        var r = s.map((e) => {
                            var { handle: t } = e;
                            return t;
                          }),
                          o = yield Promise.all(
                            r.map(e.getProductShopInfoHandle)
                          );
                        if (o && o.length) {
                          var l = o
                            .filter((e) => e)
                            .map((e, t) => {
                              var a;
                              return _objectSpread(
                                _objectSpread({}, e),
                                {},
                                {
                                  current_variant_id:
                                    null === (a = s[t]) || void 0 === a
                                      ? void 0
                                      : a.variant_id,
                                }
                              );
                            });
                          e.parsedHTMLWishlistCards({
                            parent: t,
                            products: l,
                            current_page: n,
                          });
                        }
                        return i
                          ? (yield new Promise((t) =>
                              setTimeout(t, e.throttlin + 200)
                            ),
                            e.getWishlistGuest(t, new URL(i)))
                          : (e.lastLoading = !0);
                      });
                      return function (e) {
                        return a.apply(this, arguments);
                      };
                    })()
                  )
                  .catch((a) => {
                    console.log(a), t.classList.remove("loading");
                  });
            } catch (t) {
              console.log(t);
            }
          });
          return function (e) {
            return t.apply(this, arguments);
          };
        })()
      ),
      _defineProperty(
        this,
        "getProductShopInfoHandle",
        (function () {
          var e = _asyncToGenerator(function* (e) {
            return fetch(
              window.Shopify.routes.root + "products/".concat(e, ".js")
            )
              .then((e) => (e && e.ok ? e.json() : null))
              .catch((t) => (console.log(t), null));
          });
          return function (t) {
            return e.apply(this, arguments);
          };
        })()
      ),
      _defineProperty(this, "showEmptyBlock", (e) => {
        try {
          if (!e) return null;
          var t = e.querySelector(".empty-state"),
            a = e.querySelector(".full-state");
          a.classList.remove("show"), t.classList.add("show");
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(
        this,
        "getListOfWishlists",
        _asyncToGenerator(function* () {
          try {
            var t = new URL("".concat(e.baseURL, "/lists")),
              a = { customer_id: e.shopifyCustomerId };
            return (
              Object.keys(a).forEach((e) => t.searchParams.append(e, a[e])),
              fetch(t, { method: "GET", headers: e.headers })
                .then((e) => e.json())
                .catch((t) => (console.log(t), []))
            );
          } catch (t) {
            console.log(t);
          }
        })
      ),
      _defineProperty(
        this,
        "getWishlistCustomer",
        (function () {
          var t = _asyncToGenerator(function* (t) {
            try {
              t.classList.add("loading");
              var a = yield e.getListOfWishlists();
              if (a && a.length) {
                var s = [];
                if (
                  (a.forEach((e) => {
                    var { products: t = [] } = e;
                    return s.push(...t);
                  }),
                  s.length)
                ) {
                  var i = s.map((e) => {
                      var { handle: t } = e;
                      return t;
                    }),
                    n = yield e.getProductsShopiData(s, i);
                  n &&
                    n.length &&
                    e.parsedHTMLWishlistCards({ parent: t, products: n });
                } else t.classList.remove("loading"), e.showEmptyBlock(t);
              } else t.classList.remove("loading"), e.showEmptyBlock(t);
              t.classList.remove("loading");
            } catch (t) {
              console.log(t);
            }
          });
          return function (e) {
            return t.apply(this, arguments);
          };
        })()
      ),
      _defineProperty(
        this,
        "getProductsShopiData",
        _asyncToGenerator(function* () {
          var t =
              0 < arguments.length && arguments[0] !== void 0
                ? arguments[0]
                : [],
            a =
              1 < arguments.length && arguments[1] !== void 0
                ? arguments[1]
                : [];
          try {
            if (!t.length || !a.length) return [];
            var s = Array.from(new Set(a)),
              i = (function () {
                var t = _asyncToGenerator(function* () {
                  var t,
                    a =
                      0 < arguments.length && arguments[0] !== void 0
                        ? arguments[0]
                        : [],
                    s =
                      1 < arguments.length && arguments[1] !== void 0
                        ? arguments[1]
                        : 0,
                    n =
                      2 < arguments.length && arguments[2] !== void 0
                        ? arguments[2]
                        : 15,
                    r =
                      3 < arguments.length && arguments[3] !== void 0
                        ? arguments[3]
                        : [],
                    o = a.length > n;
                  t = o ? a.slice(s, s + n).filter((e) => e) : a;
                  var l = yield Promise.all(t.map(e.getProductShopInfoHandle));
                  return l && l.length
                    ? (r.push(...l.filter((e) => e)),
                      o && s + n < a.length
                        ? (yield new Promise((t) => setTimeout(t, e.throttlin)),
                          i(a, s + n, n, r))
                        : r)
                    : [];
                });
                return function e() {
                  return t.apply(this, arguments);
                };
              })(),
              n = yield i(s);
            if (n && n.length) {
              var r = t
                .map((e) => {
                  var t,
                    a,
                    s = n.find((t) => t.handle === e.handle) || {},
                    i =
                      (null === e || void 0 === e ? void 0 : e.variant_id) ||
                      (null === e ||
                      void 0 === e ||
                      null === (t = e.pivot) ||
                      void 0 === t
                        ? void 0
                        : t.shopify_variant_id),
                    r =
                      (null === e ||
                      void 0 === e ||
                      null === (a = e.pivot) ||
                      void 0 === a
                        ? void 0
                        : a.updated_at) ||
                      (null === e || void 0 === e ? void 0 : e.updated_at);
                  return _objectSpread(
                    _objectSpread({}, s),
                    {},
                    { current_variant_id: i, upd: r }
                  );
                })
                .sort((e, t) => t.upd - e.upd)
                .reverse();
              return r;
            }
            return [];
          } catch (t) {
            console.log(t);
          }
        })
      ),
      _defineProperty(this, "getWishlistInfo", () => {
        try {
          var e = document.querySelector('[data-wishlist-list="true"]');
          if (!e) return null;
          this.shopifyCustomerId
            ? this.getWishlistCustomer(e)
            : this.uuid
            ? this.getWishlistGuest(e)
            : this.showEmptyBlock(e);
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(
        this,
        "getIdsStatusGuest",
        _asyncToGenerator(function* () {
          var t =
            0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : [];
          try {
            var a = new URL("".concat(e.baseURL, "/product_status/guest")),
              s = { uuid: e.uuid, ids: t };
            return fetch(a, {
              method: "POST",
              headers: e.headers,
              body: JSON.stringify(s),
            })
              .then((e) => e.json())
              .catch((e) => []);
          } catch (t) {
            return console.log(t), [];
          }
        })
      ),
      _defineProperty(this, "updateAllFindBtns", (e) => {
        var t = e.getAttribute("data-product-id"),
          a = e.getAttribute("data-product-variant-id"),
          s = e.getAttribute("data-wishlist-added"),
          i = Array.from(
            document.querySelectorAll(
              '[data-product-id="'
                .concat(t, '"][data-product-variant-id="')
                .concat(a, '"]')
            )
          );
        return i && i.length
          ? void ((i = i.filter((t) => t !== e)),
            i.forEach((e) => {
              e.setAttribute("data-wishlist-added", s);
            }))
          : null;
      }),
      _defineProperty(
        this,
        "getIdStatusGuest",
        (function () {
          var t = _asyncToGenerator(function* (t) {
            var { product_id: a, variant_id: s } = t;
            try {
              var i = new URL("".concat(e.baseURL, "/product_status/guest")),
                n = { uuid: e.uuid, ids: [{ product_id: a, variant_id: s }] };
              return fetch(i, {
                method: "POST",
                headers: e.headers,
                body: JSON.stringify(n),
              })
                .then((e) => e.json())
                .catch((e) => []);
            } catch (t) {
              return console.log(t), [];
            }
          });
          return function (e) {
            return t.apply(this, arguments);
          };
        })()
      ),
      _defineProperty(
        this,
        "getIdStatus",
        (function () {
          var t = _asyncToGenerator(function* (t) {
            var { product_id: a, variant_id: s } = t;
            try {
              var i = new URL("".concat(e.baseURL, "/product_status")),
                n = {
                  customer_id: e.shopifyCustomerId,
                  ids: [{ product_id: a, variant_id: s }],
                };
              return fetch(i, {
                method: "POST",
                headers: e.headers,
                body: JSON.stringify(n),
              })
                .then((e) => e.json())
                .catch((e) => []);
            } catch (t) {
              return console.log(t), [];
            }
          });
          return function (e) {
            return t.apply(this, arguments);
          };
        })()
      ),
      _defineProperty(
        this,
        "getIdsStatus",
        _asyncToGenerator(function* () {
          var t =
            0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : [];
          try {
            var a = new URL("".concat(e.baseURL, "/product_status")),
              s = { customer_id: e.shopifyCustomerId, ids: t };
            return fetch(a, {
              method: "POST",
              headers: e.headers,
              body: JSON.stringify(s),
            })
              .then((e) => e.json())
              .catch((e) => []);
          } catch (t) {
            return console.log(t), [];
          }
        })
      ),
      _defineProperty(
        this,
        "productBtnInit",
        _asyncToGenerator(function* () {
          try {
            var t =
              document.querySelector('[data-wishlist-product="true"]') || !1;
            if (!t) return null;
            if ((t.classList.add("disabled"), !e.uuid && !e.shopifyCustomerId))
              return (
                t.setAttribute("data-wishlist-added", !1),
                t.classList.remove("disabled"),
                null
              );
            var a = t.getAttribute("data-product-id"),
              s = t.getAttribute("data-product-variant-id");
            if (e.shopifyCustomerId) {
              var i,
                n = yield e.getIdStatus({ product_id: a, variant_id: s });
              if (!n || !n.length) return null;
              var r = null === (i = n[0]) || void 0 === i ? void 0 : i.status;
              t.setAttribute("data-wishlist-added", r),
                t.classList.remove("disabled");
            } else if (e.uuid) {
              var o,
                l = yield e.getIdStatusGuest({ product_id: a, variant_id: s });
              if (!l || !l.length) return null;
              var d = null === (o = l[0]) || void 0 === o ? void 0 : o.is_exist;
              t.setAttribute("data-wishlist-added", d),
                t.classList.remove("disabled");
            }
          } catch (t) {
            console.log(t);
          }
        })
      ),
      _defineProperty(
        this,
        "collectionBtnsInit",
        _asyncToGenerator(function* () {
          try {
            var t =
              Array.from(
                document.querySelectorAll(
                  '[data-wishlist-collection="true"]:not([data-wishlist-init="true"])'
                )
              ) || [];
            if (!t || !t.length) return null;
            if (!e.uuid && !e.shopifyCustomerId)
              return (
                t.forEach((e) => {
                  e.setAttribute("data-wishlist-added", !1),
                    e.classList.remove("disabled");
                }),
                null
              );
            t.forEach((e) => e.classList.add("disabled"));
            var a = t.map((e) => ({
              product_id: e.getAttribute("data-product-id"),
              variant_id: e.getAttribute("data-product-variant-id"),
            }));
            if (e.shopifyCustomerId) {
              var s = yield e.getIdsStatus(a);
              if (!s || !s.length) return null;
              s.forEach((e) => {
                var {
                    product_id: a = null,
                    variant_id: s = null,
                    status: i = !1,
                  } = e,
                  n = t.find(
                    (e) =>
                      e.getAttribute("data-product-id") == a &&
                      e.getAttribute("data-product-variant-id") == s
                  );
                n &&
                  (n.setAttribute("data-wishlist-added", i),
                  n.setAttribute("data-wishlist-init", !0),
                  n.classList.remove("disabled"));
              });
            } else if (e.uuid) {
              var i = yield e.getIdsStatusGuest(a);
              if (!i || !i.length) return null;
              i.forEach((e) => {
                var {
                    product_id: a = null,
                    variant_id: s = null,
                    is_exist: i = !1,
                  } = e,
                  n = t.find(
                    (e) =>
                      e.getAttribute("data-product-id") == a &&
                      e.getAttribute("data-product-variant-id") == s
                  );
                n &&
                  (n.setAttribute("data-wishlist-added", i),
                  n.setAttribute("data-wishlist-init", !0),
                  n.classList.remove("disabled"));
              });
            }
          } catch (t) {
            console.log(t);
          }
        })
      ),
      _defineProperty(
        this,
        "addProduct",
        (function () {
          var t = _asyncToGenerator(function* (t) {
            var { product_id: a, variant_id: s } = t;
            try {
              var i = new URL("".concat(e.baseURL, "/add_product")),
                n = {
                  product_id: a,
                  variant_id: s,
                  customer_id: e.shopifyCustomerId,
                  wishlist_ids: [],
                  uuid: e.uuid,
                };
              return fetch(i, {
                method: "POST",
                headers: e.headers,
                body: JSON.stringify(n),
              })
                .then((e) => e.json())
                .catch((e) => e);
            } catch (t) {
              console.log(t);
            }
          });
          return function (e) {
            return t.apply(this, arguments);
          };
        })()
      ),
      _defineProperty(
        this,
        "addProductGuest",
        (function () {
          var t = _asyncToGenerator(function* (t) {
            var { product_id: a, variant_id: s } = t;
            try {
              var i = new URL("".concat(e.baseURL, "/add_product/guest")),
                n = e.uuid ? e.uuid : null,
                r = { product_id: a, variant_id: s, wishlist_ids: [], uuid: n };
              return fetch(i, {
                method: "POST",
                headers: e.headers,
                body: JSON.stringify(r),
              })
                .then((e) => e.json())
                .catch((e) => e);
            } catch (t) {
              console.log(t);
            }
          });
          return function (e) {
            return t.apply(this, arguments);
          };
        })()
      ),
      _defineProperty(
        this,
        "deleteProduct",
        (function () {
          var t = _asyncToGenerator(function* (t) {
            var { product_id: a, variant_id: s } = t;
            try {
              var i = e.shopifyCustomerId ? "" : "/guest",
                n = new URL("".concat(e.baseURL, "/delete_product").concat(i)),
                r = {
                  product_id: a,
                  variant_id: s,
                  customer_id: e.shopifyCustomerId,
                  wishlist_ids: [],
                  uuid: e.uuid,
                };
              return fetch(n, {
                method: "POST",
                headers: e.headers,
                body: JSON.stringify(r),
              })
                .then((e) => e.json())
                .catch((e) => e);
            } catch (t) {
              console.log.log(t);
            }
          });
          return function (e) {
            return t.apply(this, arguments);
          };
        })()
      ),
      _defineProperty(
        this,
        "productTrigger",
        (function () {
          var t = _asyncToGenerator(function* (t) {
            try {
              var a = !!(
                  t.getAttribute("data-wishlist-added") &&
                  "false" != t.getAttribute("data-wishlist-added")
                ),
                s = t.getAttribute("data-product-id"),
                i = t.getAttribute("data-product-variant-id");
              if ((t.classList.add("disabled"), !!a)) {
                var n = yield e.deleteProduct({ product_id: s, variant_id: i });
                n.message && t.setAttribute("data-wishlist-added", !1);
              } else if (e.shopifyCustomerId) {
                var r,
                  o = yield e.addProduct({ product_id: s, variant_id: i });
                null !== o &&
                  void 0 !== o &&
                  o.message &&
                  t.setAttribute("data-wishlist-added", !0),
                  !e.uuid &&
                    null !== o &&
                    void 0 !== o &&
                    null !== (r = o.data) &&
                    void 0 !== r &&
                    r.uuid &&
                    (e.setUUID(o.data.uuid), (e.uuid = o.data.uuid));
              } else {
                var l,
                  d,
                  c = yield e.addProductGuest({ product_id: s, variant_id: i });
                null !== c &&
                  void 0 !== c &&
                  null !== (l = c.data) &&
                  void 0 !== l &&
                  l.uuid &&
                  t.setAttribute("data-wishlist-added", !0),
                  !e.uuid &&
                    null !== c &&
                    void 0 !== c &&
                    null !== (d = c.data) &&
                    void 0 !== d &&
                    d.uuid &&
                    (e.setUUID(c.data.uuid), (e.uuid = c.data.uuid));
              }
              t.classList.remove("disabled"), e.updateAllFindBtns(t);
            } catch (t) {
              console.log(t);
            }
          });
          return function (e) {
            return t.apply(this, arguments);
          };
        })()
      ),
      _defineProperty(
        this,
        "removeProductTrigger",
        (function () {
          var t = _asyncToGenerator(function* (t) {
            var a = t.getAttribute("data-product-id"),
              s = t.getAttribute("data-product-variant-id");
            t.classList.add("disabled");
            var i = yield e.deleteProduct({ product_id: a, variant_id: s });
            if (i.message) {
              var n = t.closest(".section-wishlist-card") || null,
                r = document.querySelector('[data-wishlist-list="true"]'),
                o = r.querySelector(".section-wishlist-list"),
                l = o.children.length || 0;
              if (1 >= l) {
                var d = r.querySelector(".full-state"),
                  c = r.querySelector(".empty-state");
                d.classList.remove("show"), c.classList.add("show");
              }
              return n.remove(), null;
            }
            return t.classList.add("disabled"), null;
          });
          return function (e) {
            return t.apply(this, arguments);
          };
        })()
      ),
      _defineProperty(this, "click", (t) => {
        var e =
          t.target.closest('[data-wishlist-product="true"]') ||
          t.target.closest('[data-wishlist-collection="true"]');
        if (e) return this.productTrigger(e);
        var a = t.target.closest('[data-wishlist-remove-trigger="true"]');
        if (a) return this.removeProductTrigger(a);
        var s = t.target.closest('[data-wishlist-cleanall="true"]');
        if (s) return this.wishlistCleanAll(s);
      }),
      _defineProperty(
        this,
        "cleanAllProductsGuest",
        _asyncToGenerator(function* () {
          try {
            var t = (function () {
                var a = _asyncToGenerator(function* () {
                  var a =
                      0 < arguments.length && void 0 !== arguments[0]
                        ? arguments[0]
                        : new URL("".concat(e.baseURL, "/products/guest")),
                    s =
                      1 < arguments.length && void 0 !== arguments[1]
                        ? arguments[1]
                        : [],
                    i = { uuid: e.uuid };
                  return (
                    Object.keys(i).forEach((e) =>
                      a.searchParams.append(e, i[e])
                    ),
                    fetch(a, { method: "GET", headers: e.headers })
                      .then((e) => e.json())
                      .then(
                        (function () {
                          var e = _asyncToGenerator(function* (e) {
                            var {
                              data: a = [],
                              next_page_url: i = null,
                              current_page: n = 1,
                            } = e;
                            if (!a.length && 1 == n) return s;
                            var r = a.map((e) => {
                              var { variant_id: t, product_id: a } = e;
                              return { variant_id: t, product_id: a };
                            });
                            return s.push(r), i ? t(new URL(i), s) : s;
                          });
                          return function (t) {
                            return e.apply(this, arguments);
                          };
                        })()
                      )
                  );
                });
                return function e() {
                  return a.apply(this, arguments);
                };
              })(),
              a = (function () {
                var t = _asyncToGenerator(function* () {
                  var t =
                      0 < arguments.length && void 0 !== arguments[0]
                        ? arguments[0]
                        : [],
                    s =
                      1 < arguments.length && void 0 !== arguments[1]
                        ? arguments[1]
                        : 0;
                  return t[s].length
                    ? (yield Promise.all(
                        t[s].map((t) => {
                          var { product_id: a, variant_id: s } = t;
                          return e.deleteProduct({
                            product_id: a,
                            variant_id: s,
                          });
                        })
                      ),
                      !(t[s + 1] && t[s + 1].length) ||
                        (yield new Promise((t) => setTimeout(t, e.throttlin)),
                        a(t, s + 1)))
                    : null;
                });
                return function e() {
                  return t.apply(this, arguments);
                };
              })(),
              s = yield t();
            return !!(s && s.length) && (yield a(s), !0);
          } catch (t) {
            console.log(t);
          }
        })
      ),
      _defineProperty(
        this,
        "cleanAllProductsUser",
        _asyncToGenerator(function* () {
          try {
            var t = (function () {
                var a = _asyncToGenerator(function* () {
                  var a =
                      0 < arguments.length && arguments[0] !== void 0
                        ? arguments[0]
                        : [],
                    s =
                      1 < arguments.length && arguments[1] !== void 0
                        ? arguments[1]
                        : 0,
                    i =
                      2 < arguments.length && arguments[2] !== void 0
                        ? arguments[2]
                        : 15;
                  try {
                    var n = a.length > s + i,
                      r = a;
                    return (
                      n && (r = a.slice(s, i)),
                      yield Promise.all(r.map((t) => e.deleteProduct(t))),
                      !n ||
                        (yield new Promise((t) => setTimeout(t, e.throttlin)),
                        t(a, s + i, i))
                    );
                  } catch (t) {
                    console.log(t);
                  }
                });
                return function e() {
                  return a.apply(this, arguments);
                };
              })(),
              a = yield e.getListOfWishlists();
            if (a && a.length) {
              var s = [];
              a.forEach((e) => {
                var { products: t } = e;
                return s.push(...t);
              });
              var i = s.map((e) => {
                var t;
                return {
                  variant_id:
                    null === e ||
                    void 0 === e ||
                    null === (t = e.pivot) ||
                    void 0 === t
                      ? void 0
                      : t.shopify_variant_id,
                  product_id: e.product_id,
                };
              });
              return yield t(i), !0;
            }
            return null;
          } catch (t) {
            console.log(t);
          }
        })
      ),
      _defineProperty(this, "removeHtmlCards", () => {
        try {
          var e = document.querySelector(
            '[data-wishlist-list="true"] .section-wishlist-list'
          );
          if (!e) return null;
          this.showEmptyBlock(
            document.querySelector('[data-wishlist-list="true"]')
          );
          var t = Array.from(e.children) || [];
          t.forEach((e) => {
            e && e.remove();
          });
        } catch (t) {
          console.lolg(t);
        }
      }),
      _defineProperty(this, "afterCleanScopeActions", (e) => {
        e.classList.remove("disabled"),
          this.removeHtmlCards(),
          document.dispatchEvent(new CustomEvent("close-poup"));
      }),
      _defineProperty(
        this,
        "wishlistCleanAll",
        (function () {
          var t = _asyncToGenerator(function* (t) {
            try {
              t.classList.add("disabled"),
                e.uuid
                  ? (yield e.cleanAllProductsGuest(),
                    e.afterCleanScopeActions(t))
                  : e.shopifyCustomerId &&
                    (yield e.cleanAllProductsUser(),
                    e.afterCleanScopeActions(t)),
                t.classList.remove("disabled");
            } catch (t) {
              console.log(t);
            }
          });
          return function (e) {
            return t.apply(this, arguments);
          };
        })()
      ),
      (this.token =
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiM2QxMTkzYmZkYTM1Y2ZhZjcwYWU3Y2UzMGExM2Q5ZDcxMzY2ODI3NGYzN2RkYjc2MDQ3NWE3OWVlNTMxYmNhMzhhM2Q2MjdlZDlkMDJlNjciLCJpYXQiOjE3MDM3NTk2MTYsIm5iZiI6MTcwMzc1OTYxNiwiZXhwIjozNTk3MjE1NjE2LCJzdWIiOiI3OTgyIiwic2NvcGVzIjpbXX0.V60-iqw6I99NIh-nPgT98_Sr7-1u1dbKmhpp24D4aaLJluF-aH2nnYO1YcngXZxVjvxTHAlNrEqbkd6fB3HQ8kEoT4XtMgUWYdtUXBnHRHEq9g1zBiG8o7dNQo3_I0iQFO3huKIbtAXXv8Y56u1R727J53Nzfv3WQdleihw4aPtDXevTFb2AKHzdBsg-2bjp8diUVsZqzsRAIzu1ANp7TrLMmRmJrqOnt1wGH_UTpt0p089pZx6_vBsDhSTartJCMq8nRAh8LsHVxCARFt0tRgBLgX_CrqGpoaUVJ7Fcx-LIt46X_8_dP4W_S1uh6rCr7Vu9FBcegVtowSjlwTURnmJcX5srQuIoyzPiOQGMyF68D23qtbc2s2NsRLti6BJl_5jxQpJyn9Ein9m-akSxk3gj-1BSmMCB9VFV7OkLZWofiWZ6dVtNHgVw0fYokd-r1Zb5zNIRTf5CC3WIYNpxZcw6l3XydheFAZSOI6kz72m3CzhNVjnSbquFttIel_RJEvrG-8Y7ah50g_exmNXlxyCRRBZOybc0ahlQztAX-45QJUXhbGEPeBx4I1STQwBDAX2x2ypKKJi2UfWnbfZj9U12iIhq-R6SnK7Myph91Lj8nZ7YAoiK8_HjmZW8wZbkYhp14qhUvskDOguqPKsX75AYY7fxzUTykL_G9W43Etk"),
      (this.baseURL =
        "https://advanced-wishlist.hulkapps.com/api/public/v1/wishlist"),
      (this.coockieName = "hulkwishlistuuid"),
      (this.headers = {
        Authorization: "Bearer ".concat(this.token),
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
      (this.shopifyCustomerId = null),
      (this.uuid = null),
      (this.lastLoading = !1),
      (this.throttlin = 200);
  }
  initialize() {
    var e = this;
    return _asyncToGenerator(function* () {
      var t;
      (e.shopifyCustomerId =
        null === (t = shopifycustomer) || void 0 === t ? void 0 : t.id),
        (e.uuid = e.getUUID()),
        e.shopifyCustomerId && e.uuid && (yield e.synhronizeWishlist()),
        e.productBtnInit(),
        e.collectionBtnsInit(),
        e.getWishlistInfo();
    })();
  }
  init() {
    this.initialize(),
      document.addEventListener("click", this.click),
      document.addEventListener(
        "product-wishlist-btn-update",
        this.productBtnInit
      ),
      document.addEventListener(
        "collection-wishlist-btn-update",
        this.collectionBtnsInit
      );
  }
  destroy() {
    document.removeEventListener("click", this.click),
      document.removeEventListener(
        "product-wishlist-btn-update",
        this.productBtnInit
      ),
      document.removeEventListener(
        "collection-wishlist-btn-update",
        this.collectionBtnsInit
      );
  }
}
class TableScrollCheck {
  constructor() {
    _defineProperty(this, "checkAll", () =>
      this.tables.length
        ? void this.tables.forEach((e) => {
            var t = e.offsetWidth,
              a = e.scrollWidth;
            a > t
              ? e.classList.add("hasScroll")
              : e.classList.remove("hasScroll");
          })
        : null
    ),
      (this.tables = []);
  }
  init() {
    (this.tables =
      Array.from(
        document.querySelectorAll(".flex-table-container .flex-table")
      ) || []),
      this.checkAll(),
      window.addEventListener("resize", this.checkAll);
  }
  destroy() {
    window.removeEventListener("resize", this.checkAll);
  }
}
class HoverClass {
  constructor() {
    _defineProperty(this, "closeSvgHov", (e) => {
      var t = e.target.querySelector("path[data-path-change]");
      if (!t) return null;
      var a = t.getAttribute("data-path-change"),
        s = t.getAttribute("d");
      t.setAttribute("data-path-change", s), t.setAttribute("d", a);
    }),
      _defineProperty(this, "closeSvgLeave", (e) => {
        var t = e.target.querySelector("path[data-path-change]");
        if (!t) return null;
        var a = t.getAttribute("data-path-change"),
          s = t.getAttribute("d");
        t.setAttribute("data-path-change", s), t.setAttribute("d", a);
      }),
      _defineProperty(this, "init", () => {
        (this.closesvg =
          Array.from(document.querySelectorAll(".close-animate-svg")) || []),
          this.closesvg.length &&
            this.closesvg.forEach((e) => {
              e.addEventListener("mouseenter", this.closeSvgHov),
                e.addEventListener("mouseleave", this.closeSvgLeave),
                e.addEventListener("touchstart", this.closeSvgHov),
                e.addEventListener("touchend", this.closeSvgLeave);
            }),
          document.addEventListener("hoverclass-reinit", this.init);
      }),
      (this.closesvg = []);
  }
  destroy() {
    document.removeEventListener("hoverclass-reinit", this.init),
      this.closesvg.length &&
        (this.closesvg.forEach((e) => {
          e.removeEventListener("mouseenter", this.closeSvgHov),
            e.removeEventListener("mouseleave", this.closeSvgLeave),
            e.removeEventListener("touchstart", this.closeSvgHov),
            e.removeEventListener("touchend", this.closeSvgLeave);
        }),
        (this.closesvg = []));
  }
}
class PriceDelZero {
  constructor() {
    _defineProperty(this, "removezero", (e) => {
      e.innerHTML = e.innerHTML.replace(/[.,]00(?!\d)/g, "");
    }),
      _defineProperty(this, "zerofind", () => {
        var e = Array.from(
            document.querySelectorAll(".totals .totals__total-value")
          ),
          t = Array.from(
            document.querySelectorAll(".cart-items-prices .product-option")
          ),
          a = Array.from(
            document.querySelectorAll(
              ".section-wishlist-card-options-val .price"
            )
          ),
          s = Array.from(document.querySelectorAll(".price-item")),
          i = a.concat(s).concat(t).concat(e),
          n = i.filter((e) => /.00/.test(e.textContent));
        n.length && n.forEach(this.removezero);
      }),
      _defineProperty(this, "openedMultyCurrency", () => {
        document.dispatchEvent(new CustomEvent("lenis:stop")),
          document.addEventListener(
            "click",
            () => {
              document.dispatchEvent(new CustomEvent("lenis:start"));
            },
            { once: !0 }
          );
      }),
      _defineProperty(this, "click", (t) => {
        var e = t.target.closest(".currency-switcher");
        if (e && !document.documentElement.classList.contains("lenis-stopped"))
          return this.openedMultyCurrency();
      });
  }
  init() {
    document.addEventListener("collection-wishlist-btn-update", this.zerofind),
      document.addEventListener("hoverclass-reinit", this.zerofind),
      this.zerofind(),
      document.addEventListener("click", this.click);
  }
  destroy() {
    document.removeEventListener("click", this.click),
      document.removeEventListener("hoverclass-reinit", this.zerofind),
      document.removeEventListener(
        "collection-wishlist-btn-update",
        this.zerofind
      );
  }
}
class FirstBlock {
  constructor() {
    _defineProperty(this, "checkIt", () => {
      try {
        var e = document.querySelector("header.header"),
          t = e.offsetHeight,
          a = document.querySelector("main");
        if (!a) return null;
        var s = a.firstElementChild;
        this.elems.forEach((e) => {
          var i = e.parentElement === a ? e : e.parentElement,
            n = window.getComputedStyle(e).paddingTop,
            o = e.dataset.b7FirstBlock === "1",
            r = o || parseFloat(n) < t;
          r && i == s && ((e.style.paddingTop = t + "px"), (e.dataset.b7FirstBlock = "1"));
        });
      } catch (t) {
        console.log(t);
      }
    }),
      (this.queryList = [
        ".catalog",
        ".page-width",
        ".shopify-policy__container",
      ]),
      (this.elems = []);
  }
  init() {
    (this.elems = this.queryList
      .map((e) => document.querySelector(e) || null)
      .filter((e) => e)),
      this.elems.length &&
        (this.checkIt(), window.addEventListener("resize", this.checkIt));
  }
  destroy() {
    this.elems.length &&
      (window.removeEventListener("resize", this.checkIt), (this.elems = []));
  }
}
class ToggleMoreDescriptionsIfo {
  constructor() {
    var t = Math.ceil;
    _defineProperty(this, "click", (t) => {
      var e = t.target,
        a = e.closest("button[data-show-less-info]");
      if (a) return this.showLess(t);
      var s = e.closest("button[data-show-more-info]");
      if (s) return this.showMore(t);
    }),
      _defineProperty(this, "checkContainers", () => {
        var e = Array.from(document.querySelectorAll(".content-details"));
        return e && e.length
          ? void e.forEach((e) => {
              var a = e.querySelector(".content-details-description");
              if (!a) return null;
              var s = () => {
                document.dispatchEvent(
                  new CustomEvent("check-productt-baaner-size")
                ),
                  a.removeEventListener("transitionend", s);
              };
              a.addEventListener("transitionend", s);
              var i = t(a.scrollHeight),
                n =
                  document.documentElement.offsetWidth > this.tabletTrigger
                    ? this.desctopTrigger
                    : this.mobTrigger;
              e.classList[i > n ? "remove" : "add"]("showAll");
            })
          : null;
      }),
      _defineProperty(this, "showMore", (a) => {
        var e = a.target.closest(".content-details"),
          s = e.querySelector(".content-details-description"),
          i = () => {
            s.removeEventListener("transitionend", i),
              e.classList.add("full"),
              s.removeAttribute("style"),
              document.dispatchEvent(
                new CustomEvent("check-productt-baaner-size")
              );
          };
        s.addEventListener("transitionend", i);
        var n = t(s.scrollHeight);
        s.style.maxHeight = "".concat(n, "px");
      }),
      _defineProperty(this, "showLess", (a) => {
        try {
          var e = a.target.closest(".content-details"),
            s = e.querySelector(".content-details-description"),
            i = () => {
              s.removeEventListener("transitionend", i),
                e.classList.remove("full"),
                s.removeAttribute("style"),
                document.dispatchEvent(
                  new CustomEvent("check-productt-baaner-size")
                );
            };
          s.addEventListener("transitionend", i);
          var n = t(s.scrollHeight);
          s.style.maxHeight = "".concat(n, "px");
        } catch (t) {
          console.log(t);
        }
      }),
      (this.tabletTrigger = 690),
      (this.desctopTrigger = 200),
      (this.mobTrigger = 290);
  }
  init() {
    this.checkContainers(),
      document.addEventListener("click", this.click),
      window.addEventListener("resize", this.checkContainers);
  }
  destroy() {
    document.removeEventListener("click", this.click),
      window.removeEventListener("resize", this.checkContainers);
  }
}
class WelcomeBannerProductMatginHekper {
  constructor() {
    var e = Math.ceil;
    _defineProperty(this, "check", () => {
      var t = document.querySelector(".welcome-banner--product");
      if (!t) return null;
      if (document.documentElement.offsetWidth >= this.triggerW)
        t.removeAttribute("style");
      else {
        var a = t.querySelector(".product-menu");
        if (a) {
          var s = e(a.offsetHeight);
          console.log(s), (t.style.marginBottom = "".concat(s, "px"));
        }
      }
    }),
      _defineProperty(this, "trotle", () => setTimeout(this.check, 250)),
      (this.triggerW = 691);
  }
  init() {
    this.trotle(),
      document.addEventListener("check-productt-baaner-size", this.trotle),
      window.addEventListener("resize", this.trotle);
  }
  destroy() {
    window.removeEventListener("resize", this.trotle),
      document.removeEventListener("check-productt-baaner-size", this.trotle);
  }
}
var FirsTBlock = new FirstBlock();
FirsTBlock.init(), OBSERVER_LOADERS.push(FirsTBlock);
var ACTIVE_LINK = new ActiveLink();
ACTIVE_LINK.init(), OBSERVER_LOADERS.push(ACTIVE_LINK);
var BagContrLL = new BagControll();
OBSERVER_LOADERS.push(BagContrLL);
var SEARCHControll = new SearchControll();
OBSERVER_LOADERS.push(SEARCHControll);
var HEADERControll = new HeaderControll();
OBSERVER_LOADERS.push(HEADERControll);
var LogCONTROLL = new LogControll();
OBSERVER_LOADERS.push(LogCONTROLL);
var FOOterControll = new FooterControll();
OBSERVER_LOADERS.push(FOOterControll);
var WISHLISTAIPI = new WishlistApi();
OBSERVER_LOADERS.push(WISHLISTAIPI);
var TableScrollCheCk = new TableScrollCheck();
OBSERVER_LOADERS.push(TableScrollCheCk);
var HoverCLass = new HoverClass();
OBSERVER_LOADERS.push(HoverCLass);
var PriceDelZerO = new PriceDelZero();
OBSERVER_LOADERS.push(PriceDelZerO);
var toggleMoreDescriptionsIfo = new ToggleMoreDescriptionsIfo();
OBSERVER_LOADERS.push(toggleMoreDescriptionsIfo);
var welcomeBannerProductMatginHekper = new WelcomeBannerProductMatginHekper();
OBSERVER_LOADERS.push(welcomeBannerProductMatginHekper);
class PreloaderAction {
  constructor() {
    var e = Math.round;
    _defineProperty(this, "setClasses", () => {
      var t = Array.from(this.preloader.children),
        a = e(t.length / 2) - 1;
      return (
        t[a] && t[a].classList.add("main"),
        t[a - 1] && t[a - 1].classList.add("prev"),
        t[a + 1] && t[a + 1].classList.add("next"),
        !0
      );
    }),
      _defineProperty(this, "setStatus", () => {
        var e = document.querySelector(".wrapper") || null;
        e && e.setAttribute("data-preloaderend", !0);
      }),
      _defineProperty(
        this,
        "preloaderPlay",
        () => sessionStorage.getItem("preloader-play") || !1
      ),
      _defineProperty(
        this,
        "isTablet",
        () => document.documentElement.offsetWidth <= this.tabletbreakpoint
      ),
      _defineProperty(this, "playPreloder", () => {
        var e = getScrollbarWidth();
        (this.preloader.style.paddingRight = e + "px"),
          this.setClasses(),
          disableScroll();
        var t = Array.from(this.preloader.children),
          a = t.find((e) => e.classList.contains("main"));
        this.isTablet() &&
          (t = t.filter(
            (e) =>
              e.classList.contains("main") ||
              e.classList.contains("prev") ||
              e.classList.contains("next")
          ));
        var s = this.isTablet() ? 0.07 : 0.03,
          n = s;
        t.forEach((e, r) => {
          (e.style.transitionDelay = n + "s"),
            (n += s),
            e.classList.add("transform"),
            r == t.length - 1 &&
              e.addEventListener("transitionend", (s) => {
                "transform" === s.propertyName &&
                  (t.forEach((e) => e.removeAttribute("style")),
                  this.preloader.classList.add("bigger"),
                  a.addEventListener("transitionend", (e) => {
                    "width" === e.propertyName &&
                      (this.preloader.classList.add("hide"),
                      this.preloader.addEventListener("transitionend", (e) => {
                        "opacity" == e.propertyName &&
                          requestAnimationFrame(() => {
                            enableScroll(),
                              this.preloader.remove(),
                              sessionStorage.setItem("preloader-play", !0),
                              this.setStatus();
                          });
                      }));
                  }));
              });
        });
      }),
      (this.preloader = document.querySelector(".preloader")),
      (this.tabletbreakpoint = 690);
  }
  init() {
    return this.preloader
      ? this.preloaderPlay()
        ? (this.preloader.remove(), this.setStatus())
        : this.playPreloder()
      : this.setStatus();
  }
  destroy() {}
}
var PRELOADER = new PreloaderAction();
class ScaleElemScrollDowm {
  constructor() {
    var e = Math.min;
    _defineProperty(this, "initAll", () => {
      (this.scrollDown = !!(window.pageYOffset > this.currentScrollpos)),
        (this.currentScrollpos = window.pageYOffset),
        this.elements.forEach(this.checkElem);
    }),
      _defineProperty(this, "resize", () =>
        this.windowHeight == document.documentElement.clientHeight
          ? null
          : void ((this.windowHeight = document.documentElement.clientHeight),
            this.elements.forEach((e) => {
              var t = e.parentElement,
                a = t.offsetHeight,
                s = (a / this.windowHeight).toFixed(2);
              e.setAttribute("data-cof", s),
                (this.endScrollPos = t.offsetHeight / 2),
                e.removeAttribute("style");
            }),
            this.initAll())
      ),
      _defineProperty(this, "getTransormProperty", function () {
        var e =
            0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : "",
          t =
            1 < arguments.length && arguments[1] !== void 0
              ? arguments[1]
              : "scale";
        try {
          var a = e.split(" ");
          if (!t.length) return null;
          var s;
          switch (
            (a.forEach((e) => {
              e.includes(t) && (s = e);
            }),
            t)
          ) {
            case "scale":
              var i = s.match(/scale\((\d+(\.\d+)?)\)/);
              return parseFloat(i[1]);
            default:
              return 0;
          }
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(this, "checkElem", (t) => {
        try {
          var a = +t.getAttribute("data-cof") || 1,
            s = this.endScrollPos - this.startScrollPos,
            i = Math.max(0, e(this.currentScrollpos - this.startScrollPos, s)),
            n = e(1, i / s),
            r = this.interpolate(this.startScale, this.endScale, n);
          if (
            t.getBoundingClientRect().width < this.minAcceptW &&
            r < this.getTransormProperty(t.style.transform)
          )
            return null;
          (t.style.transform = "scale(".concat(r, ")")),
            (t.style.opacity = 0.95 > r ? 0 : r);
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(this, "setSvgPathDelay", () => {
        var e = 0.3,
          t = 0.055;
        this.elements.forEach((a) => {
          var s = a.querySelector("svg");
          if (!s) return null;
          var i = Array.from(s.children) || [],
            n = e;
          i.forEach((e) => {
            (e.style.transitionDelay = n + "s"), (n += t);
          });
        });
      }),
      (this.elements = []),
      (this.currentScrollpos = 0),
      (this.scrollDown = !1),
      (this.startScale = 1),
      (this.endScale = 0.3),
      (this.windowHeight = null),
      (this.startScrollPos = 0),
      (this.endScrollPos = 0),
      (this.minAcceptW = 200);
  }
  interpolate(e, t, a) {
    return e + (t - e) * a;
  }
  init() {
    (this.elements =
      Array.from(
        document.querySelectorAll('[data-scale-scroll-down-element="true"]')
      ) || []),
      this.elements.length &&
        (this.setSvgPathDelay(),
        this.resize(),
        window.addEventListener("scroll", this.initAll),
        window.addEventListener("resize", this.resize));
  }
  destroy() {
    (this.windowHeight = null),
      this.elements.length &&
        (window.removeEventListener("scroll", this.initAll),
        window.removeEventListener("resize", this.resize),
        (this.elements = []));
  }
}
class RunningLine {
  constructor() {
    var e = Math.max;
    _defineProperty(this, "cloneElement", (e) => {
      var t = e.cloneNode(!0);
      t.removeAttribute("data-marquee-init"),
        t.removeAttribute("data-marquee-speed"),
        t.classList.remove("startRunLine"),
        (t.style.marginLeft = "".concat(this.getMargin(e), "px")),
        e.after(t),
        e.after(t.cloneNode(!0)),
        requestAnimationFrame(initLazy),
        e.setAttribute("data-cloned", !0);
    }),
      _defineProperty(this, "requestAnim", () =>
        setTimeout(this.setMarquee, 200)
      ),
      _defineProperty(this, "getMargin", (e) =>
        e.hasAttribute("data-marquee-margin")
          ? parseFloat(e.getAttribute("data-marquee-margin"))
          : this.defaultCloneMargin
      ),
      _defineProperty(this, "observeClassChanges", (e) => {
        var t = new MutationObserver((a) => {
          for (var s of a)
            if ("attributes" === s.type && "class" === s.attributeName)
              return t.disconnect(), setTimeout(() => this.setRunElem(e), 200);
        });
        t.observe(e, { attributes: !0 });
      }),
      _defineProperty(this, "setRunElem", (t) => {
        try {
          t.setAttribute("data-marquee-init", !0);
          var a = t.offsetWidth + this.getMargin(t),
            s = +t.getAttribute("data-marquee-speed") || 5,
            i = e(s),
            n = { elem: t, width: a, speed: i };
          this.cloneElement(t),
            (t = t.parentElement),
            t.style.setProperty("--RunLineDuration", "".concat(i, "s")),
            t.style.setProperty("--RunLineWidth", "-".concat(a, "px")),
            t.classList.add("startRunLine"),
            this.marqueeElems.push(n);
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(this, "updateRunElem", (t) => {
        var { elem: a } = t;
        try {
          var s = a.offsetWidth + this.getMargin(a),
            i = +a.getAttribute("data-marquee-speed") || 5,
            n = e(i),
            r = { elem: a, width: s, speed: n };
          return (
            (a = a.parentElement),
            a.style.setProperty("--RunLineDuration", "".concat(n, "s")),
            a.style.setProperty("--RunLineWidth", "-".concat(s, "px")),
            (t = r),
            !0
          );
        } catch (t) {
          console.log(t);
        }
      }),
      _defineProperty(this, "setMarquee", () => {
        var e = Array.from(
            document.querySelectorAll('[data-marquee-init="false"]')
          ),
          t = e.filter((e) =>
            e.closest('[data-marquee-parent="true"][data-style-loaded="true"]')
          );
        t.length &&
          t.forEach((e) => {
            if (!this.marqueeElems.some((t) => t.elem === e)) {
              var t = e.parentElement;
              if (t) {
                var a = e.closest(".overflowhide");
                if (!a) {
                  var s = document.createElement("div");
                  (s.className = "overflowhide"),
                    t.replaceWith(s),
                    s.appendChild(t);
                }
                t.setAttribute("data-marquee-show", !0);
              }
              return "img" === e.tagName.toLowerCase()
                ? this.observeClassChanges(e)
                : this.setRunElem(e);
            }
          });
      }),
      _defineProperty(this, "resizeUpdate", () => {
        this.screenWidth !== document.documentElement.offsetWidth &&
          this.marqueeElems.length &&
          ((this.screenWidth = document.documentElement.offsetWidth),
          setTimeout(() => this.marqueeElems.forEach(this.updateRunElem)));
      }),
      _defineProperty(this, "init", () => {
        this.setMarquee(),
          document.addEventListener("loadedStyle", this.requestAnim),
          window.addEventListener("resize", this.resizeUpdate);
      }),
      (this.marqueeElems = []),
      (this.defaultCloneMargin = 100),
      (this.screenWidth = document.documentElement.offsetWidth);
  }
  destroy() {
    document.removeEventListener("loadedStyle", this.requestAnim),
      window.removeEventListener("resize", this.resizeUpdate),
      this.marqueeElems.length && (this.marqueeElems = []);
  }
}
var scope = [new ScaleElemScrollDowm(), new RunningLine()];
OBSERVER_LOADERS.push(...scope),
  document.addEventListener("DOMContentLoaded", () => {
    OBSERVER_LOADERS.forEach((e) => {
      "function" == typeof e.init && e.init();
    }),
      LOADED_SCRIPTS_PACK &&
        LOADED_SCRIPTS_PACK.length &&
        LOADED_SCRIPTS_PACK.forEach((e) => {
          "function" == typeof e.init && e.init();
        });
  }),
  window.addEventListener("load", () => {
    initLazy(),
      ANIME_ELEMENTS_OBSERVER && ANIME_ELEMENTS_OBSERVER.init(),
      PRELOADER && PRELOADER.init();
  }),
  (window.onbeforeunload = function () {
    goAwayFromPage();
  });
